import React__default, { useState, createElement, memo, cloneElement, Component, Fragment, forwardRef, useRef, useEffect, useLayoutEffect, Children } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import ReactDOM__default, { createPortal } from 'react-dom';
import memoize from 'memoizee';

var GlobalType;
(function (GlobalType) {
    GlobalType["default"] = "default";
    GlobalType["primary"] = "primary";
    GlobalType["secondary"] = "secondary";
    GlobalType["gray"] = "gray";
    GlobalType["success"] = "success";
    GlobalType["warning"] = "warning";
    GlobalType["error"] = "error";
    GlobalType["white"] = "white";
})(GlobalType || (GlobalType = {}));
var TextAlign;
(function (TextAlign) {
    TextAlign["notSet"] = "not-set";
    TextAlign["left"] = "left";
    TextAlign["right"] = "right";
    TextAlign["center"] = "center";
})(TextAlign || (TextAlign = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var classNames = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(function (className) { return className !== ''; }).join(' ');
};
var testEnvironments = ['test', 'testing'];
var isTestEnv = function () { var _a; return testEnvironments.includes((_a = process.env.NODE_ENV) !== null && _a !== void 0 ? _a : ''); };
var getTestId = function (prefix, id, suffix, suffix2) {
    return id
        ? prefix + "__" + id + (suffix ? "--" + suffix : '') + (suffix2 ? "--" + suffix2 : '')
        : undefined;
};
var getTestIdWithParentTestId = function (parentTestId, testId) {
    if (!parentTestId && !testId)
        return undefined;
    if (!parentTestId)
        return testId;
    return "" + parentTestId + (testId ? "__" + testId : '');
};

var IconSize;
(function (IconSize) {
    IconSize["regular"] = "regular";
    IconSize["xs"] = "fa-xs";
    IconSize["sm"] = "fa-sm";
    IconSize["lg"] = "fa-lg";
    IconSize["x2"] = "fa-2x";
    IconSize["x3"] = "fa-3x";
    IconSize["x5"] = "fa-5x";
    IconSize["x7"] = "fa-7x";
    IconSize["x10"] = "fa-10x";
})(IconSize || (IconSize = {}));
var IconFamily;
(function (IconFamily) {
    IconFamily["brands"] = "fab";
    IconFamily["solid"] = "fas";
    IconFamily["regular"] = "far";
})(IconFamily || (IconFamily = {}));
var IconType;
(function (IconType) {
    IconType["android"] = "fa-android";
    IconType["angleDown"] = "fa-angle-down";
    IconType["angleDoubleDown"] = "fa-angle-double-down";
    IconType["angleUp"] = "fa-angle-up";
    IconType["angleRight"] = "fa-angle-right";
    IconType["angleLeft"] = "fa-angle-left";
    IconType["apple"] = "fa-apple";
    IconType["link"] = "fa-link";
    IconType["arrowRight"] = "fa-arrow-right";
    IconType["arrowCircleRight"] = "fas fa-arrow-circle-right";
    IconType["arrowLeft"] = "fa-arrow-left";
    IconType["ban"] = "fa-ban";
    IconType["bars"] = "fa-bars";
    IconType["borderAll"] = "fa-border-all";
    IconType["desktop"] = "fa-desktop";
    IconType["chartBar"] = "fa-chart-bar";
    IconType["chevronRight"] = "fa-chevron-right";
    IconType["chevronLeft"] = "fa-chevron-left";
    IconType["calendarAlt"] = "far fa-calendar-alt";
    IconType["calendarEdit"] = "fa-calendar-edit";
    IconType["camera"] = "fa-camera";
    IconType["check"] = "fa-check";
    IconType["checkCircle"] = "fa-check-circle";
    IconType["chrome"] = "fab fa-chrome";
    IconType["clock"] = "fa-clock";
    IconType["circle"] = "fa-circle";
    IconType["comments"] = "fa-comments";
    IconType["copy"] = "fa-copy";
    IconType["cog"] = "fa-cog";
    IconType["dots"] = "fa-comment-dots";
    IconType["download"] = "far fa-download";
    IconType["edit"] = "fa-edit";
    IconType["ellipsisHoriz"] = "fa-ellipsis-h";
    IconType["envelope"] = "fa-envelope";
    IconType["exclamation"] = "fa-exclamation";
    IconType["exclamationCircle"] = "fa-exclamation-circle";
    IconType["eye"] = "fa-eye";
    IconType["eyeSlash"] = "fa-eye-slash";
    IconType["facebookSquare"] = "fa-facebook-square";
    IconType["flag"] = "fa-flag";
    IconType["frown"] = "fa-frown";
    IconType["gem"] = "fa-gem";
    IconType["globe"] = "fa-globe";
    IconType["gift"] = "fa-gift";
    IconType["grin"] = "fa-grin";
    IconType["handSparkles"] = "fa-hand-sparkles";
    IconType["heart"] = "fa-heart";
    IconType["home"] = "fa-home-alt";
    IconType["infoCircle"] = "fa-info-circle";
    IconType["instagram"] = "fa-instagram";
    IconType["linkedin"] = "fa-linkedin";
    IconType["listUl"] = "fa-list-ul";
    IconType["locationUnavailable"] = "fa-map-marker-slash";
    IconType["lockAlt"] = "far fa-lock-alt";
    IconType["lock"] = "fa-lock";
    IconType["unlock"] = "fa-unlock";
    IconType["mapMarker"] = "fa-map-marker";
    IconType["mapMarkerAlt"] = "fa-map-marker-alt";
    IconType["mapMarkerSlash"] = "far fa-map-marker-slash";
    IconType["mapMarked"] = "fa-map-marked";
    IconType["mapMarkedAlt"] = "fa-map-marked-alt";
    IconType["meh"] = "fa-meh";
    IconType["minus"] = "fa-minus";
    IconType["minusCircle"] = "fa-minus-circle";
    IconType["mobileAlt"] = "fa-mobile-alt";
    IconType["mobile"] = "far fa-mobile";
    IconType["user"] = "fa-user";
    IconType["userFriends"] = "fa-user-friends";
    IconType["users"] = "fa-users";
    IconType["phone"] = "fa-phone";
    IconType["phoneAlt"] = "fa-phone-alt";
    IconType["phoneLaptop"] = "fa-phone-laptop";
    IconType["phoneSlash"] = "fa-phone-slash";
    IconType["pizza"] = "fa-pizza-slice";
    IconType["play"] = "fa-play";
    IconType["playCircle"] = "fa-play-circle";
    IconType["plus"] = "fa-plus";
    IconType["pencil"] = "fa-pencil";
    IconType["powerOff"] = "fa-power-off";
    IconType["puzzlePiece"] = "fa-puzzle-piece";
    IconType["questionCircle"] = "fa-question-circle";
    IconType["rocket"] = "fa-rocket";
    IconType["sadTear"] = "fa-sad-tear";
    IconType["search"] = "fa-search";
    IconType["searchMinus"] = "fa-search-minus";
    IconType["settings"] = "fa-cog";
    IconType["shieldAlt"] = "fa-shield-alt";
    IconType["signOut"] = "fa-sign-out-alt";
    IconType["sirenOn"] = "fa-siren-on";
    IconType["sliders"] = "fas fa-sliders-v";
    IconType["smile"] = "fa-smile";
    IconType["sortDown"] = "fa-sort-down";
    IconType["sortUp"] = "fa-sort-up";
    IconType["star"] = "fa-star";
    IconType["syncAlt"] = "fas fa-sync-alt";
    IconType["tablet"] = "fa-tablet-alt";
    IconType["thumbsUp"] = "fa-thumbs-up";
    IconType["thumbsDown"] = "fa-thumbs-down";
    IconType["times"] = "fa-times";
    IconType["timesCircle"] = "fa-times-circle";
    IconType["trashAlt"] = "fa-trash-alt";
    IconType["twitterSquare"] = "fa-twitter-square";
    IconType["youtube"] = "fa-youtube";
    IconType["youtubeSquare"] = "fa-youtube-square";
    IconType["windows"] = "fa-windows";
})(IconType || (IconType = {}));
var IconColor;
(function (IconColor) {
    IconColor["notSet"] = "not-set";
    IconColor["error"] = "error";
    IconColor["warning"] = "warning";
    IconColor["success"] = "success";
    IconColor["secondary"] = "secondary";
    IconColor["neutral"] = "neutral";
    IconColor["black"] = "black";
    IconColor["primary"] = "primary";
    IconColor["regular"] = "regular";
    IconColor["contrast"] = "contrast";
    IconColor["contrastBlue"] = "contrast-secondary";
    IconColor["greenDecorationContrast"] = "green-decoration-contrast";
    IconColor["grayLight"] = "gray-light";
})(IconColor || (IconColor = {}));
var SvgColor;
(function (SvgColor) {
    SvgColor["notSet"] = "not-set";
    SvgColor["error"] = "error";
    SvgColor["warning"] = "warning";
    SvgColor["success"] = "success";
    SvgColor["secondary"] = "secondary";
    SvgColor["neutral"] = "neutral";
    SvgColor["black"] = "black";
    SvgColor["primary"] = "primary";
    SvgColor["regular"] = "regular";
    SvgColor["contrast"] = "contrast";
    SvgColor["grayLight"] = "gray-light";
})(SvgColor || (SvgColor = {}));

var IconTest;
(function (IconTest) {
    IconTest["prefix"] = "Icon";
})(IconTest || (IconTest = {}));
var Icon = function (_a) {
    var type = _a.type, _b = _a.size, size = _b === void 0 ? IconSize.regular : _b, _c = _a.family, family = _c === void 0 ? IconFamily.regular : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.ariaHidden, ariaHidden = _e === void 0 ? true : _e, ariaLabel = _a.ariaLabel, role = _a.role, title = _a.title, tabIndex = _a.tabIndex, _f = _a.color, color = _f === void 0 ? IconColor.notSet : _f, square = _a.square, circle = _a.circle, testId = _a.testId, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur;
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement("div", { className: classNames('rck-icon', "rck-icon--" + color, square ? "rck-icon--square" : '', square ? "rck-icon--square-" + size : '', circle ? 'rck-icon--circle' : '', className), onClick: onClick, onFocus: onFocus, onBlur: onBlur, "aria-hidden": ariaHidden, "aria-label": ariaLabel, title: title, role: role, tabIndex: tabIndex, onKeyDown: onClick, "data-testid": getTestId(IconTest.prefix, testId) },
        React__default.createElement("i", { className: classNames(family, type, size !== IconSize.regular ? size : '') })));
};
Icon.displayName = 'Icon';
var Icon$1 = React__default.memo(Icon);

var AccordionItemTest;
(function (AccordionItemTest) {
    AccordionItemTest["prefix"] = "AccordionItem";
})(AccordionItemTest || (AccordionItemTest = {}));
var AccordionItem = function (_a) {
    var testId = _a.testId, title = _a.title, content = _a.content, isOpen = _a.isOpen, _b = _a.isHighlightedWhenOpen, isHighlightedWhenOpen = _b === void 0 ? true : _b, icon = _a.icon, onClick = _a.onClick;
    var iconVisible = icon === null || icon === void 0 ? void 0 : icon.visible;
    var iconType = icon === null || icon === void 0 ? void 0 : icon.type;
    var iconColor = (icon === null || icon === void 0 ? void 0 : icon.color) || 'black';
    var iconBackgroundColor = (icon === null || icon === void 0 ? void 0 : icon.backgroundColor) || 'transparent';
    return (React__default.createElement("div", { role: "button", "data-testid": getTestId(AccordionItemTest.prefix, testId), onClick: onClick, onKeyDown: onClick, tabIndex: 0, className: classNames('rck-accordion-item', isOpen ? 'rck-accordion-item--open' : '', isHighlightedWhenOpen ? 'rck-accordion-item--highlight' : '') },
        React__default.createElement("div", { className: "rck-accordion-item__container" },
            iconVisible && (React__default.createElement("div", { className: "rck-accordion-item__icon-wrapper", style: {
                    color: iconColor,
                    backgroundColor: iconBackgroundColor,
                } }, iconType && (React__default.createElement(Icon$1, { className: "rck-accordion-item__icon", type: iconType, family: IconFamily.solid })))),
            React__default.createElement("div", { className: "rck-accordion-item__content-wrapper" },
                React__default.createElement("div", { className: "rck-accordion-item__title" }, title),
                React__default.createElement("div", { className: "rck-accordion-item__content" }, content)),
            React__default.createElement("div", { className: "rck-accordion-item__right-icon" },
                React__default.createElement(Icon$1, { family: IconFamily.regular, type: isOpen ? IconType.minus : IconType.plus })))));
};
AccordionItem.displayName = 'AccordionItem';

/**
 * TODO Support for multiple columns is missing.
 *
 * If in the future we need it, we'll need to rely on component
 *  composition. For example through the children prop.
 */
var AccordionTest;
(function (AccordionTest) {
    AccordionTest["prefix"] = "Accordion";
})(AccordionTest || (AccordionTest = {}));
var Accordion = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'primary' : _b, items = _a.items, testId = _a.testId;
    var _c = useState(null), keyOfOpenedItem = _c[0], setKeyOfOpenedItem = _c[1];
    var className = type === 'primary'
        ? 'rck-accordion rck-accordion--primary'
        : 'rck-accordion rck-accordion--secondary';
    return (React__default.createElement("div", { className: className, "data-testid": getTestId(AccordionTest.prefix, testId) }, items.map(function (itemProps) { return (React__default.createElement(AccordionItem, __assign({}, itemProps, { isOpen: itemProps.key === keyOfOpenedItem, onClick: function () {
            return setKeyOfOpenedItem(itemProps.key === keyOfOpenedItem ? null : itemProps.key);
        } }))); })));
};
Accordion.displayName = 'Accordion';

var AccordionMenuTest;
(function (AccordionMenuTest) {
    AccordionMenuTest["prefix"] = "AccordionMenu";
})(AccordionMenuTest || (AccordionMenuTest = {}));
var AccordionMenu = function (_a) {
    var isVisible = _a.isVisible, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId, children = _a.children;
    return (React__default.createElement("ul", { className: classNames('rck-accordionMenu', isVisible ? 'rck-accordionMenu--is-visible' : '', className), "data-testid": getTestId(AccordionMenuTest.prefix, testId) }, children));
};
AccordionMenu.displayName = 'AccordionMenu';

var TransparentButtonTest;
(function (TransparentButtonTest) {
    TransparentButtonTest["prefix"] = "TransparentButton";
})(TransparentButtonTest || (TransparentButtonTest = {}));
var TransparentButton = function (_a) {
    var children = _a.children, _b = _a.htmlType, htmlType = _b === void 0 ? 'button' : _b, testId = _a.testId, _c = _a.className, className = _c === void 0 ? '' : _c, disabled = _a.disabled, onClick = _a.onClick, fillAvailableSpace = _a.fillAvailableSpace;
    return (React__default.createElement("button", { className: classNames('rck-transparent-button', disabled ? 'rck-transparent-button--disabled' : '', fillAvailableSpace ? 'rck-transparent-button--fill' : '', className), "data-testid": getTestId(TransparentButtonTest.prefix, testId), onClick: onClick, disabled: disabled, type: htmlType }, children));
};
var TransparentButton$1 = React__default.memo(TransparentButton);

var AccountInfoHeaderTest;
(function (AccountInfoHeaderTest) {
    AccountInfoHeaderTest["prefix"] = "AccountInfoHeader";
})(AccountInfoHeaderTest || (AccountInfoHeaderTest = {}));
var AccountInfoHeader = function (_a) {
    var name = _a.name, logoImage = _a.logoImage, _b = _a.showGift, showGift = _b === void 0 ? false : _b, onClickGift = _a.onClickGift, expand = _a.expand, testId = _a.testId, _c = _a.className, className = _c === void 0 ? '' : _c;
    var renderContent = function () { return (React__default.createElement("div", { className: "rck-account-info-header__user-info__name" },
        showGift && (React__default.createElement(Icon$1, { type: IconType.gift, size: IconSize.xs, color: IconColor.contrastBlue, family: IconFamily.solid, square: true, className: "rck-account-info-header__user-info__gift" })),
        name)); };
    return (React__default.createElement("div", { className: classNames('rck-account-info-header', expand ? 'rck-account-info-header--expanded' : '', className), "data-testid": getTestId(AccountInfoHeaderTest.prefix, testId) },
        React__default.createElement("div", { className: "rck-account-info-header__header" }, logoImage),
        React__default.createElement("div", { className: "rck-account-info-header__user-info" },
            expand && showGift && (React__default.createElement(TransparentButton$1, { onClick: onClickGift }, renderContent())),
            expand && !showGift && renderContent())));
};
AccountInfoHeader.displayName = 'AccountInfoHeader';
var AccountInfoHeader$1 = React__default.memo(AccountInfoHeader);

var AlertBoxType;
(function (AlertBoxType) {
    AlertBoxType["error"] = "error";
    AlertBoxType["warning"] = "warning";
    AlertBoxType["success"] = "success";
    AlertBoxType["info"] = "info";
})(AlertBoxType || (AlertBoxType = {}));
var AlertBoxTest;
(function (AlertBoxTest) {
    AlertBoxTest["prefix"] = "AlertBox";
    AlertBoxTest["actionElement"] = "Action__close";
})(AlertBoxTest || (AlertBoxTest = {}));
var AlertBox = function (_a) {
    var _b = _a.type, type = _b === void 0 ? AlertBoxType.error : _b, showInfoIcon = _a.showInfoIcon, showCloseIcon = _a.showCloseIcon, centered = _a.centered, fullWidth = _a.fullWidth, _c = _a.rounded, rounded = _c === void 0 ? true : _c, icon = _a.icon, testId = _a.testId, _d = _a.className, className = _d === void 0 ? '' : _d, children = _a.children, onClose = _a.onClose;
    return (React__default.createElement("div", { className: classNames('rck-alert-box', "rck-alert-box--" + type, fullWidth ? 'rck-alert-box--full-width' : '', !rounded ? 'rck-alert-box--no-rounded' : '', className), "data-testid": getTestId(AlertBoxTest.prefix, testId) },
        showInfoIcon && (React__default.createElement("div", { className: "rck-alert-box__icon" },
            icon,
            !icon && React__default.createElement(Icon$1, { type: IconType.infoCircle, size: IconSize.lg }))),
        React__default.createElement("div", { className: classNames('rck-alert-box__text', centered ? "rck-alert-box__text--centered" : '') }, children),
        showCloseIcon && (React__default.createElement("div", { className: "rck-alert-box__icon-right", onClick: onClose, role: "button", onKeyDown: onClose, tabIndex: 0, "data-testid": getTestId(AlertBoxTest.prefix, testId, AlertBoxTest.actionElement) },
            React__default.createElement(Icon$1, { type: IconType.times, size: IconSize.lg })))));
};
AlertBox.displayName = 'AlertBox';
var AlertBox$1 = React__default.memo(AlertBox);

var Link = function (_a) {
    var Anchor = _a.useAsLink, ariaLabel = _a.ariaLabel, testId = _a.testId, role = _a.role, href = _a.href, icon = _a.icon, _b = _a.iconPosition, iconPosition = _b === void 0 ? 'right' : _b, disabled = _a.disabled, _c = _a.className, className = _c === void 0 ? '' : _c, onClick = _a.onClick, children = _a.children;
    return (React__default.createElement("span", { className: classNames('rck-link', disabled ? 'rck-link--disabled' : '', className) },
        Anchor && (React__default.createElement(Anchor, { to: href, className: "", "aria-label": ariaLabel, "data-testid": testId, onClick: disabled ? undefined : onClick },
            icon && iconPosition === 'left' && (React__default.createElement("span", { className: "rck-link__icon--left" }, icon)),
            children,
            icon && iconPosition === 'right' && (React__default.createElement("span", { className: "rck-link__icon--right" }, icon)))),
        !Anchor && (React__default.createElement("a", { href: href, "aria-label": ariaLabel, "data-testid": testId, onClick: disabled ? undefined : onClick, role: role },
            icon && iconPosition === 'left' && (React__default.createElement("span", { className: "rck-link__icon--left" }, icon)),
            children,
            icon && iconPosition === 'right' && (React__default.createElement("span", { className: "rck-link__icon--right" }, icon))))));
};
Link.displayName = 'Link';
var Link$1 = React__default.memo(Link);

var ActionInputIconPosition;
(function (ActionInputIconPosition) {
    ActionInputIconPosition["left"] = "left";
    ActionInputIconPosition["right"] = "right";
})(ActionInputIconPosition || (ActionInputIconPosition = {}));
var ActionInputButtonType;
(function (ActionInputButtonType) {
    ActionInputButtonType["button"] = "button";
    ActionInputButtonType["submit"] = "submit";
})(ActionInputButtonType || (ActionInputButtonType = {}));
var ActionInputTest;
(function (ActionInputTest) {
    ActionInputTest["prefix"] = "ActionInput";
    ActionInputTest["label"] = "ActionInput__label";
})(ActionInputTest || (ActionInputTest = {}));
var ActionInput = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, icon = _a.icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? ActionInputIconPosition.left : _c, _d = _a.iconWithColor, iconWithColor = _d === void 0 ? true : _d, _e = _a.placeholder, placeholder = _e === void 0 ? '' : _e, _f = _a.text, text = _f === void 0 ? '' : _f, _g = _a.block, block = _g === void 0 ? false : _g, _h = _a.href, href = _h === void 0 ? '' : _h, useAsLink = _a.useAsLink, ariaLabel = _a.ariaLabel, testId = _a.testId, _j = _a.buttonType, buttonType = _j === void 0 ? ActionInputButtonType.button : _j, error = _a.error, _k = _a.onClick, onClick = _k === void 0 ? undefined : _k, onKeyDown = _a.onKeyDown;
    var classes = classNames("rck-action-input", error ? 'rck-action-input--error' : '', className, block ? 'rck-action-input--block' : '');
    var renderIcon = function (position) {
        return icon &&
            (!position || (position && position === iconPosition)) && (React__default.createElement("div", { className: classNames('rck-action-input__container-icon', "rck-action-input__container-icon--" + iconPosition) }, React__default.cloneElement(icon, {
            className: classNames('rck-action-input__icon', iconWithColor ? 'rck-action-input__icon--with-color' : ''),
        })));
    };
    var renderLabel = function (dataTestId) { return (
    // TODO: review this
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    React__default.createElement("label", { className: classNames('rck-action-input__text', text ? '' : 'rck-action-input__text__placeholder'), "data-testid": getTestId(ActionInputTest.label, dataTestId) }, text || placeholder)); };
    if (href || useAsLink) {
        return (React__default.createElement(Link$1, { useAsLink: useAsLink, href: href, className: classNames(classes, 'rck-action-input__anchor'), ariaLabel: ariaLabel, testId: getTestId(ActionInputTest.prefix, testId) },
            renderIcon(),
            renderLabel(testId)));
    }
    return (React__default.createElement("button", { type: buttonType, className: classes, onClick: onClick, onKeyDown: onKeyDown, "aria-label": ariaLabel, "data-testid": getTestId(ActionInputTest.prefix, testId) },
        renderIcon(ActionInputIconPosition.left),
        renderLabel(testId),
        renderIcon(ActionInputIconPosition.right)));
};
ActionInput.displayName = 'ActionInput';
var ActionInput$1 = React__default.memo(ActionInput);

/* eslint-disable jsx-a11y/no-static-element-interactions */
var AvatarStatus;
(function (AvatarStatus) {
    AvatarStatus["active"] = "active";
    AvatarStatus["offline"] = "offline";
    AvatarStatus["warning"] = "warning";
    AvatarStatus["danger"] = "danger";
    AvatarStatus["dark"] = "dark";
})(AvatarStatus || (AvatarStatus = {}));
var AvatarSize;
(function (AvatarSize) {
    AvatarSize["extraExtraSmall"] = "xx-small";
    AvatarSize["extraSmall"] = "x-small";
    AvatarSize["small"] = "small";
    AvatarSize["medium"] = "medium";
    AvatarSize["large"] = "large";
})(AvatarSize || (AvatarSize = {}));
var AvatarTest;
(function (AvatarTest) {
    AvatarTest["prefix"] = "Avatar";
})(AvatarTest || (AvatarTest = {}));
var Avatar = function (_a) {
    var disabled = _a.disabled, discarded = _a.discarded, _b = _a.size, size = _b === void 0 ? AvatarSize.medium : _b, AvatarIcon = _a.icon, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.debug, debug = _d === void 0 ? false : _d, testId = _a.testId, onClick = _a.onClick, children = _a.children, _e = _a.emptyBackground, emptyBackground = _e === void 0 ? false : _e;
    return (createElement("div", { className: classNames('rck-avatar', disabled ? 'rck-avatar--disabled' : '', discarded ? 'rck-avatar--discarded' : '', debug ? 'rck-avatar--debug' : '', onClick ? 'rck-avatar--interactive' : '', "rck-avatar--" + size, "", className), onClick: disabled ? undefined : onClick, onKeyDown: disabled ? undefined : onClick, 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: onClick ? 0 : undefined, role: onClick ? 'button' : undefined, "data-testid": getTestId(AvatarTest.prefix, testId) },
        createElement("div", { className: classNames(emptyBackground
                ? "rck-avatar__content--empty rck-avatar__content--empty--" + size
                : 'rck-avatar__content') }, children),
        AvatarIcon && createElement("div", { className: "rck-avatar__icon" }, AvatarIcon)));
};
Avatar.displayName = 'Avatar';

var BadgeType;
(function (BadgeType) {
    BadgeType["error"] = "error";
    BadgeType["warning"] = "warning";
    BadgeType["neutral"] = "neutral";
    BadgeType["brand"] = "brand";
    BadgeType["secondary"] = "secondary";
    BadgeType["success"] = "success";
    BadgeType["dark"] = "dark";
    BadgeType["contrast"] = "contrast";
})(BadgeType || (BadgeType = {}));
var BadgeTest;
(function (BadgeTest) {
    BadgeTest["prefix"] = "Badge";
})(BadgeTest || (BadgeTest = {}));
var Badge = function (_a) {
    var text = _a.text, type = _a.type, _b = _a.size, size = _b === void 0 ? 'regular' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId;
    return (React__default.createElement("div", { className: classNames('rck-badge', "rck-badge--" + type, "rck-badge--" + size, className), "data-testid": getTestId(BadgeTest.prefix, testId) }, text));
};
Badge.displayName = 'Badge';
var Badge$1 = React__default.memo(Badge);

var ButtonSize;
(function (ButtonSize) {
    ButtonSize["extraSmall"] = "extra-small";
    ButtonSize["small"] = "small";
    ButtonSize["medium"] = "medium";
    ButtonSize["big"] = "big";
})(ButtonSize || (ButtonSize = {}));
var ButtonIconPosition;
(function (ButtonIconPosition) {
    ButtonIconPosition["left"] = "left";
    ButtonIconPosition["right"] = "right";
})(ButtonIconPosition || (ButtonIconPosition = {}));
var ButtonTest;
(function (ButtonTest) {
    ButtonTest["prefix"] = "Button";
})(ButtonTest || (ButtonTest = {}));
var Button = function (_a) {
    var children = _a.children, label = _a.label, _b = _a.htmlType, htmlType = _b === void 0 ? 'button' : _b, bigRounded = _a.bigRounded, _c = _a.hollow, hollow = _c === void 0 ? false : _c, _d = _a.plain, plain = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.shadow, shadow = _g === void 0 ? false : _g, _h = _a.block, block = _h === void 0 ? false : _h, _j = _a.inverted, inverted = _j === void 0 ? false : _j, _k = _a.centered, centered = _k === void 0 ? true : _k, _l = _a.iconPosition, iconPosition = _l === void 0 ? false : _l, form = _a.form, icon = _a.icon, _m = _a.size, size = _m === void 0 ? undefined : _m, _o = _a.className, className = _o === void 0 ? '' : _o, testId = _a.testId, _p = _a.onClick, onClick = _p === void 0 ? undefined : _p;
    var renderRightIcon = iconPosition === ButtonIconPosition.right && icon
        ? cloneElement(icon, { className: 'rck-btn__icon' })
        : '';
    var renderLeftIcon = iconPosition === ButtonIconPosition.left && icon
        ? cloneElement(icon, { className: 'rck-btn__icon' })
        : '';
    return (createElement("button", { disabled: disabled, className: classNames('rck-btn', bigRounded ? 'rck-btn--big-rounded' : '', hollow ? 'rck-btn--hollow' : '', plain ? 'rck-btn--plain' : '', loading ? 'rck-btn--loading' : '', disabled ? 'c--btn--disabled' : '', shadow ? 'c--btn-with-shadow' : '', block ? 'rck-btn--block' : '', inverted ? 'rck-btn--inverted' : '', size ? "rck-btn--" + size : '', centered ? "rck-btn--centered" : '', iconPosition
            ? "rck-btn--with-icon\n          rck-btn--with-icon-" + iconPosition
            : '', className), type: htmlType, form: form, onClick: onClick, "data-testid": getTestId(ButtonTest.prefix, testId) },
        renderLeftIcon,
        createElement("span", { className: "rck-btn__label" }, children || label),
        renderRightIcon));
};
Button.displayName = 'Button';
var Button$1 = memo(Button);

var ActionableContentTest;
(function (ActionableContentTest) {
    ActionableContentTest["prefix"] = "ActionableContent";
})(ActionableContentTest || (ActionableContentTest = {}));
var ActionableContent = function (_a) {
    var onClick = _a.onClick, fillAvailableSpace = _a.fillAvailableSpace, disabled = _a.disabled, testId = _a.testId, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children;
    return (React__default.createElement("div", { className: classNames('rck-actionable-content', fillAvailableSpace ? 'rck-actionable-content--fill' : '', className), "data-testid": getTestId(ActionableContentTest.prefix, testId), onClick: disabled ? undefined : onClick, "aria-hidden": "true" }, children));
};
ActionableContent.displayName = 'ActionableContent';

var MoreActionsButtonTest;
(function (MoreActionsButtonTest) {
    MoreActionsButtonTest["prefix"] = "MoreActionsButton";
})(MoreActionsButtonTest || (MoreActionsButtonTest = {}));
var MoreActionsButton = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled, _b = _a.size, size = _b === void 0 ? IconSize.lg : _b, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId;
    return (React__default.createElement(TransparentButton$1, { className: classNames('rck-btn-more', disabled ? 'rck-btn-more--disabled' : '', className), onClick: onClick, disabled: disabled, testId: getTestId(MoreActionsButtonTest.prefix, testId) },
        React__default.createElement("div", { className: "rck-btn-more__icon-wrapper" },
            React__default.createElement(Icon$1, { type: IconType.ellipsisHoriz, color: IconColor.regular, size: size }))));
};
MoreActionsButton.displayName = 'MoreActionsButton';
var MoreActionsButton$1 = React__default.memo(MoreActionsButton);

/* eslint-disable jsx-a11y/anchor-is-valid */
var CardTest;
(function (CardTest) {
    CardTest["prefix"] = "Card";
    CardTest["footerActionLeft"] = "CardFooter__action__left";
    CardTest["footerActionRight"] = "CardFooter__action__right";
    CardTest["headerTitle"] = "CardHeader__title";
    CardTest["headerAction"] = "CardHeader__action";
    CardTest["body"] = "CardBody";
})(CardTest || (CardTest = {}));
var CardHeader = function (_a) {
    var headerBorder = _a.border, title = _a.title, headerAction = _a.actionElement, type = _a.type, onClickHeaderAction = _a.onClickAction, banner = _a.banner, testId = _a.testId;
    return (createElement("div", { className: classNames('rck-card__header', headerBorder ? 'rck-card__header--with-border' : '', banner ? 'rck-card__header--with-banner' : '', "rck-card__header--header-colors-" + type) },
        !banner && title && (createElement("h3", { className: "rck-card__header__title", "data-testid": getTestId(CardTest.prefix, testId, CardTest.headerTitle) }, title)),
        !banner && headerAction && (createElement("span", { className: "rck-card__action rck-card__action--right" },
            createElement(Link$1, { onClick: onClickHeaderAction, testId: getTestId(CardTest.prefix, testId, CardTest.headerAction) }, headerAction))),
        banner && banner));
};
CardHeader.displayName = 'CardHeader';
var CardFooter = function (_a) {
    var footerActionElement = _a.actionElement, onClickAction = _a.onClickAction, testId = _a.testId;
    return (createElement("div", { className: "rck-card__footer" }, footerActionElement && (createElement("span", { className: "rck-card__action rck-card__action--center" },
        createElement(Link$1, { onClick: onClickAction, "data-testid": getTestId(CardTest.prefix, testId, CardTest.footerActionRight) }, footerActionElement)))));
};
CardFooter.displayName = 'CardFooter';
var Card = function (_a) {
    var header = _a.header, footer = _a.footer, displayAll = _a.displayAll, fullHeight = _a.fullHeight, fullWidth = _a.fullWidth, minHeight = _a.minHeight, _b = _a.className, className = _b === void 0 ? '' : _b, width = _a.width, height = _a.height, children = _a.children, _c = _a.type, type = _c === void 0 ? GlobalType.default : _c, testId = _a.testId;
    return (createElement("div", { className: classNames('rck-card', displayAll ? 'rck-card--display-all' : '', fullHeight ? 'rck-card--full-height' : '', fullWidth ? 'rck-card--full-width' : '', type
            ? "rck-card--" + type + " rck-card--bck-color-" + type
            : 'rck-card--bck-color-default', className), style: { width: width, height: height }, "data-testid": getTestId(CardTest.prefix, testId) },
        header && createElement(CardHeader, __assign({}, header, { type: type })),
        createElement("div", { className: classNames('rck-card__body', minHeight ? "rck-card__body--min-height-" + minHeight : ''), "data-testid": getTestId(CardTest.prefix, testId, CardTest.body) }, children),
        footer && createElement(CardFooter, __assign({}, footer))));
};
Card.displayName = 'Card';

var CheckboxTest;
(function (CheckboxTest) {
    CheckboxTest["prefix"] = "Checkbox";
    CheckboxTest["box"] = "Box";
})(CheckboxTest || (CheckboxTest = {}));
var Checkbox = function (_a) {
    var name = _a.name, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, label = _a.label, checked = _a.checked, disabled = _a.disabled, block = _a.block, testId = _a.testId, onClick = _a.onClick, onBlur = _a.onBlur, onFocus = _a.onFocus, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp;
    var handleOnClick = function () {
        if (!disabled && onClick) {
            onClick(!checked);
        }
    };
    return (createElement("label", { htmlFor: name, className: classNames(className, 'rck-checkbox', block ? 'rck-checkbox--block' : '', disabled ? 'rck-checkbox--disabled' : ''), "data-testid": getTestId(CheckboxTest.prefix, testId) },
        label || children,
        createElement("input", { className: "rck-checkbox__input", type: "checkbox", checked: checked, name: name, onChange: function () { } }),
        createElement("div", { className: classNames('rck-checkbox__square', checked ? 'rck-checkbox__square--checked' : '', disabled ? 'rck-checkbox__square--disabled' : ''), onClick: handleOnClick, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseUp: onMouseUp, role: "checkbox", onKeyPress: handleOnClick, tabIndex: 0, "aria-checked": checked, "data-testid": getTestId(CheckboxTest.prefix, testId, CheckboxTest.box) }, checked && (createElement(Icon$1, { family: IconFamily.solid, type: IconType.check, className: classNames('rck-checkbox__square__icon', disabled ? 'rck-checkbox__square__icon--disabled' : '') })))));
};
Checkbox.displayName = 'Checkbox';

var CopyBoxTest;
(function (CopyBoxTest) {
    CopyBoxTest["prefix"] = "CopyBox";
})(CopyBoxTest || (CopyBoxTest = {}));
var CopyBox = function (_a) {
    var text = _a.text, url = _a.url, confirmationText = _a.confirmationText, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId, onClickCallback = _a.onClickCallback;
    var _c = useState(false), confirmationVisible = _c[0], setConfirmationVisible = _c[1];
    var clickHandler = function () {
        window.navigator.clipboard.writeText(url);
        setConfirmationVisible(true);
        onClickCallback();
    };
    return (createElement("div", { className: classNames('rck-copybox', className), "data-testid": getTestId(CopyBoxTest.prefix, testId) },
        createElement("div", { className: "rck-copybox__widget" },
            createElement("p", { className: classNames('rck-copybox__text') }, text),
            createElement("div", { className: "rck-copybox__icon", role: "button", tabIndex: 0, onKeyDown: clickHandler, onClick: clickHandler },
                createElement(Icon$1, { type: IconType.copy, color: IconColor.contrast }))),
        confirmationVisible && (createElement("small", { className: "rck-copybox__copy-confirmation" }, confirmationText))));
};
CopyBox.displayName = 'CopyBox';

var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.portalContainer = null;
        _this.portal = document.createElement('div');
        _this.createPortalContainer = function () {
            var name = _this.props.name;
            var portalContainer = document.getElementById(name);
            if (!portalContainer && !isTestEnv()) {
                throw new Error("Remember to add an HTML element with id \"" + name + "\" in the index.html file.");
            }
            return portalContainer || document.body;
        };
        return _this;
    }
    Portal.prototype.componentDidMount = function () {
        var _a;
        this.portalContainer = this.createPortalContainer() || null;
        // TODO: review this, it will fail silently. Is that what we want?
        (_a = this.portalContainer) === null || _a === void 0 ? void 0 : _a.appendChild(this.portal);
    };
    Portal.prototype.componentWillUnmount = function () {
        if (this.portalContainer) {
            this.portalContainer.removeChild(this.portal);
        }
    };
    Portal.prototype.render = function () {
        var children = this.props.children;
        return createPortal(children, this.portal);
    };
    return Portal;
}(Component));

/* eslint-disable jsx-a11y/no-static-element-interactions */
var PortalModalTest;
(function (PortalModalTest) {
    PortalModalTest["prefix"] = "PortalModal";
    PortalModalTest["closeButton"] = "Action-close";
})(PortalModalTest || (PortalModalTest = {}));
var PortalModal = /** @class */ (function (_super) {
    __extends(PortalModal, _super);
    function PortalModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClose = function (evt) {
            var onClose = _this.props.onClose;
            _this.stopEventPropagation(evt);
            onClose();
        };
        _this.stopEventPropagation = function (evt) {
            evt.stopPropagation();
        };
        return _this;
    }
    PortalModal.prototype.render = function () {
        var _a = this.props, overlayId = _a.overlayId, _b = _a.overlayClassName, overlayClassName = _b === void 0 ? '' : _b, _c = _a.modalWrapperClassName, modalWrapperClassName = _c === void 0 ? '' : _c, modalWrapperWidth = _a.modalWrapperWidth, modalWrapperHeight = _a.modalWrapperHeight, _d = _a.closeButtonClassName, closeButtonClassName = _d === void 0 ? '' : _d, _e = _a.animationEnabled, animationEnabled = _e === void 0 ? true : _e, children = _a.children, testId = _a.testId;
        return (createElement(Portal, { name: PortalModal.portalId },
            createElement(RemoveScroll, null,
                createElement("div", { id: overlayId, className: "rck-portal-modal__overlay " + overlayClassName, onClick: this.handleClose, "data-testid": getTestId(PortalModalTest.prefix, testId) },
                    createElement("div", { className: "rck-portal-modal__wrapper " + (animationEnabled ? 'rck-portal-modal__wrapper--animated' : '') + " " + modalWrapperClassName, style: {
                            width: modalWrapperWidth,
                            height: modalWrapperHeight,
                        }, onClick: this.stopEventPropagation, role: "dialog" },
                        children,
                        createElement(Icon$1, { type: IconType.times, family: IconFamily.regular, className: classNames('rck-portal-modal__close-btn', closeButtonClassName || ''), onClick: this.handleClose, ariaLabel: "close", testId: getTestId(PortalModalTest.prefix, testId, PortalModalTest.closeButton) }))))));
    };
    PortalModal.portalId = 'styleguide-react-portal-modal';
    return PortalModal;
}(Component));

var ModalStyledText = function (_a) {
    var _b = _a.textAlign, textAlign = _b === void 0 ? 'center' : _b, _c = _a.marginBottom, marginBottom = _c === void 0 ? '16' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, children = _a.children;
    return (React__default.createElement("p", { className: classNames('rck-modal__text', "rck-modal__text--" + textAlign, "rck-modal__text--mbottom-" + marginBottom, className) }, children));
};

var ModalCloseIconType;
(function (ModalCloseIconType) {
    ModalCloseIconType["black"] = "black";
    ModalCloseIconType["white"] = "white";
})(ModalCloseIconType || (ModalCloseIconType = {}));
var ModalButtonsAlignment;
(function (ModalButtonsAlignment) {
    ModalButtonsAlignment["row"] = "row";
    ModalButtonsAlignment["column"] = "column";
})(ModalButtonsAlignment || (ModalButtonsAlignment = {}));
var ModalTest;
(function (ModalTest) {
    ModalTest["prefix"] = "Modal";
    ModalTest["title"] = "Title_content";
    ModalTest["body"] = "Body_content";
})(ModalTest || (ModalTest = {}));
var isBodyText = function (children) {
    return typeof children === 'string';
};
var Modal = function (_a) {
    var header = _a.header, className = _a.className, width = _a.width, height = _a.height, _b = _a.type, type = _b === void 0 ? GlobalType.primary : _b, title = _a.title, buttons = _a.buttons, _c = _a.buttonsAlignment, buttonsAlignment = _c === void 0 ? ModalButtonsAlignment.column : _c, animationEnabled = _a.animationEnabled, testId = _a.testId, onClickClose = _a.onClickClose, children = _a.children;
    var renderHeader = header && (createElement("div", { className: "rck-modal__header" }, header.icon &&
        cloneElement(header.icon, {
            className: 'rck-modal__header-icon',
        })));
    var renderButtons = buttons && (createElement("div", { className: classNames(buttonsAlignment === ModalButtonsAlignment.row
            ? 'rck-modal__buttons--row'
            : '', 'rck-modal__buttons') }, // eslint-disable-next-line react/no-array-index-key
    buttons.map(function (button, key) { return cloneElement(button, { key: key }); })));
    var renderBody = (createElement("div", { className: classNames('rck-modal__body', header ? 'rck-modal__body--with-header' : '') },
        title && (createElement("h3", { "data-testid": getTestId(ModalTest.prefix, testId, ModalTest.title), className: "rck-modal__title" }, title)),
        children && (createElement("div", { "data-testid": getTestId(ModalTest.prefix, testId, ModalTest.body), className: "rck-modal__content" }, isBodyText(children) ? (createElement(ModalStyledText, null, children)) : (children))),
        renderButtons));
    return (createElement(PortalModal, { closeButtonClassName: "rck-modal__close-btn--negative", onClose: onClickClose, modalWrapperClassName: className, modalWrapperWidth: width ? width + "px" : undefined, modalWrapperHeight: height ? height + "px" : undefined, animationEnabled: animationEnabled, testId: testId },
        createElement("div", { className: classNames('rck-modal', type ? "rck-modal--" + type : '') },
            renderHeader,
            renderBody)));
};
Modal.displayName = 'Modal';

// TODO: We have to review this because the main role of the menu should be "navigation" but we are using
var MenuItemTest;
(function (MenuItemTest) {
    MenuItemTest["prefix"] = "MenuItem";
    MenuItemTest["actionElement"] = "Action-link";
})(MenuItemTest || (MenuItemTest = {}));
var MenuItemContent = function (_a) {
    var menuItem = _a.menuItem, showBadge = _a.showBadge, isLoading = _a.isLoading, isActive = _a.isActive, isHeader = _a.isHeader, expanded = _a.expanded, onClick = _a.onClick, testId = _a.testId;
    return (createElement("li", { key: menuItem.key, className: "rck-menu-item__item-wrapper", "data-testid": getTestId(MenuItemTest.prefix, testId, menuItem.key) },
        createElement("div", { className: classNames('rck-menu-item__item', "rck-menu-item__" + menuItem.key, isLoading ? 'rck-menu-item__item--blank' : '', isHeader ? 'rck-menu-item__item--header' : '', isActive ? 'rck-menu-item__item--active' : '', !expanded ? 'rck-menu-item__item--no-expanded' : ''), key: menuItem.key, onClick: isLoading ? undefined : onClick, onKeyDown: isLoading ? undefined : onClick, "data-testid": getTestId(MenuItemTest.prefix, testId, menuItem.key, MenuItemTest.actionElement), tabIndex: isHeader ? undefined : 0, role: isHeader ? undefined : 'button' },
            createElement("span", { className: classNames('rck-menu-item__text', isActive ? 'rck-menu-item__text--active' : '') },
                isHeader && (createElement("strong", null, menuItem.content ? menuItem.content : menuItem.translation)),
                !isHeader &&
                    (menuItem.content ? menuItem.content : menuItem.translation)),
            showBadge && menuItem.isPremium && (createElement(Badge$1, { className: "rck-menu-item__badge", type: menuItem.isPremium ? BadgeType.brand : BadgeType.success, text: menuItem.isPremium ? 'Premium' : '' })))));
};
var MenuItem = function (props) {
    var children = props.children, menuItem = props.menuItem;
    return (createElement(Fragment, null,
        children,
        menuItem.showContent && createElement(MenuItemContent, __assign({}, props))));
};
MenuItem.displayName = 'MenuItem';
var MenuItem$1 = memo(MenuItem);

var ScrollableContentTest;
(function (ScrollableContentTest) {
    ScrollableContentTest["prefix"] = "ScrollableContent";
    ScrollableContentTest["scroll"] = "Scroll";
})(ScrollableContentTest || (ScrollableContentTest = {}));
var ScrollableContent = function (_a) {
    var height = _a.height, hideScrollbar = _a.hideScrollbar, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId, children = _a.children;
    return (createElement("div", { className: classNames('rck-scrollable-content', className), "data-testid": getTestId(ScrollableContentTest.prefix, testId), style: { height: height } },
        createElement("div", { className: classNames('rck-scrollable-content__scroll', hideScrollbar ? 'rck-scrollable-content__scroll--no-scrollbar' : ''), "data-testid": getTestId(ScrollableContentTest.prefix, testId, ScrollableContentTest.scroll) }, children)));
};
ScrollableContent.displayName = 'ScrollableContent';

var MenuTest;
(function (MenuTest) {
    MenuTest["prefix"] = "Menu";
})(MenuTest || (MenuTest = {}));
var Menu = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId, items = _a.items, selectedRule = _a.selectedRule, _c = _a.showBadge, showBadge = _c === void 0 ? true : _c, _d = _a.isDataReady, isDataReady = _d === void 0 ? true : _d, scrollable = _a.scrollable, onClick = _a.onClick, _e = _a.onClickAccordionMenu, onClickAccordionMenu = _e === void 0 ? function () { } : _e, _f = _a.accordionMenuIsVisible, accordionMenuIsVisible = _f === void 0 ? false : _f, profileInfoHeader = _a.profileInfoHeader, expanded = _a.expanded;
    var renderChildren = function (children, isLoading) {
        return children.map(function (item) {
            var isChildrenActive = selectedRule === item.key;
            return (createElement(MenuItem$1, { key: item.key, menuItem: item, onClick: function () { return onClick(item.key); }, showBadge: showBadge, isLoading: isLoading, isActive: isChildrenActive, expanded: expanded, testId: testId }));
        });
    };
    var renderMenu = function () {
        return items.map(function (rule) {
            var isLoading = !isDataReady && rule.needsData;
            var isActive = selectedRule === rule.key;
            if (rule.children) {
                var children = rule.children;
                return (createElement(Fragment, { key: rule.key },
                    createElement(MenuItem$1, { menuItem: rule, onClick: function () { return onClickAccordionMenu(!accordionMenuIsVisible); }, showBadge: showBadge, isLoading: isLoading, isActive: isActive, isHeader: true, expanded: expanded, testId: testId }),
                    createElement("ul", { className: classNames('rck-menu__section', className) }, renderChildren(children, isLoading))));
            }
            return (createElement(MenuItem$1, { key: rule.key, menuItem: rule, onClick: function () { return onClick(rule.key); }, showBadge: showBadge, isLoading: isLoading, isActive: isActive, expanded: expanded, testId: testId }));
        });
    };
    return (createElement("div", { className: classNames('rck-menu', !expanded ? 'rck-menu--no-expanded' : '', className), "datatest-id": getTestId(MenuTest.prefix, testId) },
        profileInfoHeader && (createElement("div", { className: "rck-menu__profile-info-header" }, profileInfoHeader)),
        createElement("ul", { className: "rck-menu__list" },
            scrollable && (createElement(ScrollableContent, { hideScrollbar: true }, renderMenu())),
            !scrollable && renderMenu())));
};
Menu.displayName = 'Menu';

function fallbackMathMedia (query) {
  if (typeof matchMedia !== 'function') {
    return null
  }
  return matchMedia(query)
}

function omitMatchMediaResult (matchMediaResult) {
  if (!matchMediaResult) {
    return null
  }
  return { media: matchMediaResult.media, matches: matchMediaResult.matches }
}

function useMedia (query) {
  var result = React__default.useState(function () {
    return omitMatchMediaResult(fallbackMathMedia(query))
  });
  var setResult = result[1];

  var callback = React__default.useCallback(function (matchMediaResult) {
    return setResult(omitMatchMediaResult(matchMediaResult))
  }, [setResult]);

  React__default.useEffect(
    function () {
      var matchMediaResult = fallbackMathMedia(query);
      callback(matchMediaResult);
      matchMediaResult.addListener(callback);
      return function () { return matchMediaResult.removeListener(callback) }
    },
    [callback, query]
  );

  return result[0]
}

function useMediaPredicate (query) {
  var result = useMedia(query);
  return (result && result.matches) || false
}

var reactMediaHook = {
  useMedia: useMedia,
  useMediaPredicate: useMediaPredicate
};
var reactMediaHook_2 = reactMediaHook.useMediaPredicate;

var flexItemClassNames = function (_a) {
    var order = _a.order, flexBasis = _a.flexBasis, flexGrow = _a.flexGrow, flexShrink = _a.flexShrink, alignSelf = _a.alignSelf;
    var hasProps = order || flexBasis || flexGrow || flexShrink || alignSelf;
    return hasProps
        ? classNames('rck-layout-item', 'rck-flex-layout-item', order ? "rck-flex-layout-item--order-" + order : '', flexBasis
            ? "rck-flex-layout-item--flex-basis-" + flexBasis.replace('%', 'pc')
            : '', flexGrow
            ? "rck-flex-layout-item--flex-grow-" + flexGrow.replace('%', 'pc')
            : '', flexShrink
            ? "rck-flex-layout-item--flex-shrink-" + flexShrink.replace('%', 'pc')
            : '', alignSelf ? "rck-flex-layout-item--flex-alignself-" + alignSelf : '')
        : '';
};
var flexItemClassNames$1 = memoize(flexItemClassNames);

var layoutTextClassNames = function (_a) {
    var lineHeight = _a.lineHeight, noWrap = _a.noWrap;
    return classNames(lineHeight ? "rck-layout--line-height-" + lineHeight.replace('.', '-') : '', noWrap ? 'rck-layout--nowrap' : '');
};
var layoutTextClassNames$1 = memoize(layoutTextClassNames);

var spacingClassNames = function (_a) {
    var marginLeft = _a.marginLeft, marginBottom = _a.marginBottom, marginTop = _a.marginTop, marginRight = _a.marginRight, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom, padding = _a.padding, margin = _a.margin, minHeight = _a.minHeight, maxHeight = _a.maxHeight, minWidth = _a.minWidth, maxWidth = _a.maxWidth, height = _a.height, width = _a.width;
    return classNames(padding ? "rck-layout--padding-spacing-" + padding : '', margin ? "rck-layout--margin-spacing-" + margin : '', marginLeft ? "rck-layout--margin-left-spacing-" + marginLeft : '', marginRight ? "rck-layout--margin-right-spacing-" + marginRight : '', marginTop ? "rck-layout--margin-top-spacing-" + marginTop : '', marginBottom ? "rck-layout--margin-bottom-spacing-" + marginBottom : '', paddingLeft ? "rck-layout--padding-left-spacing-" + paddingLeft : '', paddingRight ? "rck-layout--padding-right-spacing-" + paddingRight : '', paddingTop ? "rck-layout--padding-top-spacing-" + paddingTop : '', paddingBottom ? "rck-layout--padding-bottom-spacing-" + paddingBottom : '', minHeight ? "rck-layout--min-height-" + minHeight.replace('%', 'pc') : '', maxHeight ? "rck-layout--max-height-" + maxHeight.replace('%', 'pc') : '', minWidth ? "rck-layout--min-width-" + minWidth.replace('%', 'pc') : "", maxWidth ? "rck-layout--max-width-" + maxWidth.replace('%', 'pc') : '', height ? "rck-layout--height-" + height.replace('%', 'pc') : '', width ? "rck-layout--width-" + width.replace('%', 'pc') : '');
};
var spacingClassNames$1 = memoize(spacingClassNames);

var flexLayoutClassNames = function (mainaxis, layoutTextProps, layoutSpacingProps, layoutflexItemProps, wrap, mainaxisAlignment, crossaxisAlignment, crossaxisLineSpacing, matchParentHeight, display, position, hasBox, scrollY, backgroundColor, textAlignement, className) {
    if (position === void 0) { position = 'inherit'; }
    if (className === void 0) { className = ''; }
    return classNames('rck-layout', 'rck-flex-layout', mainaxis ? "rck-flex-layout--main-axis-" + mainaxis : '', wrap ? "rck-flex-layout--wrap-" + wrap : '', mainaxisAlignment
        ? "rck-flex-layout--main-axis-alignment-" + mainaxisAlignment
        : '', crossaxisAlignment
        ? "rck-flex-layout--cross-axis-alignment-" + crossaxisAlignment
        : '', crossaxisLineSpacing
        ? "rck-flex-layout--cross-axis-line-spacing" + crossaxisLineSpacing
        : '', matchParentHeight ? 'rck-flex-layout--match-parent-height' : '', spacingClassNames$1(layoutSpacingProps), flexItemClassNames$1(layoutflexItemProps), layoutTextClassNames$1(layoutTextProps), display ? "rck-flex-layout--" + display : '', position !== 'inherit' ? "rck-layout--position-" + position : '', scrollY ? 'rck-layout--scroll-y' : '', hasBox ? 'rck-layout--box' : '', backgroundColor ? "rck-layout--bck-color-" + backgroundColor : '', textAlignement ? "rck-layout--text-alignement-" + textAlignement : '', className);
};
var flexLayoutClassNames$1 = memoize(flexLayoutClassNames);

var FlexLayoutTest;
(function (FlexLayoutTest) {
    FlexLayoutTest["prefix"] = "FlexLayout";
})(FlexLayoutTest || (FlexLayoutTest = {}));
var FlexLayout = forwardRef(function (props, ref) {
    var mainaxis = props.mainaxis, wrap = props.wrap, mainaxisAlignment = props.mainaxisAlignment, crossaxisAlignment = props.crossaxisAlignment, crossaxisLineSpacing = props.crossaxisLineSpacing, marginLeft = props.marginLeft, marginRight = props.marginRight, marginTop = props.marginTop, marginBottom = props.marginBottom, paddingLeft = props.paddingLeft, paddingRight = props.paddingRight, paddingTop = props.paddingTop, paddingBottom = props.paddingBottom, margin = props.margin, padding = props.padding, minHeight = props.minHeight, minWidth = props.minWidth, maxHeight = props.maxHeight, maxWidth = props.maxWidth, width = props.width, height = props.height, noWrap = props.noWrap, lineHeight = props.lineHeight, hasBox = props.hasBox, order = props.order, flexGrow = props.flexGrow, flexShrink = props.flexShrink, flexBasis = props.flexBasis, alignSelf = props.alignSelf, _a = props.matchParentHeight, matchParentHeight = _a === void 0 ? false : _a, _b = props.display, display = _b === void 0 ? 'flex' : _b, position = props.position, left = props.left, right = props.right, bottom = props.bottom, top = props.top, scrollY = props.scrollY, backgroundColor = props.backgroundColor, textAlignement = props.textAlignement, _c = props.className, className = _c === void 0 ? '' : _c, children = props.children, testId = props.testId;
    return (createElement("div", { ref: ref, style: {
            left: left,
            right: right,
            top: top,
            bottom: bottom,
        }, className: flexLayoutClassNames$1(mainaxis, { lineHeight: lineHeight, noWrap: noWrap }, {
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight,
            marginTop: marginTop,
            paddingBottom: paddingBottom,
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            paddingTop: paddingTop,
            padding: padding,
            margin: margin,
            minHeight: minHeight,
            minWidth: minWidth,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            width: width,
            height: height,
        }, {
            order: order,
            flexGrow: flexGrow,
            flexShrink: flexShrink,
            flexBasis: flexBasis,
            alignSelf: alignSelf,
        }, wrap, mainaxisAlignment, crossaxisAlignment, crossaxisLineSpacing, matchParentHeight, display, position, hasBox, scrollY, backgroundColor, textAlignement, className), "data-testid": getTestId(FlexLayoutTest.prefix, testId) }, children));
});
FlexLayout.displayName = 'FlexLayout';

var getCentered = function (centerX, position) {
    if (!centerX)
        return '';
    return centerX && (position === 'absolute' || position === 'fixed')
        ? 'rck-layout--center-x-absolute'
        : 'rck-layout--center-x';
};
var layoutClassNames = function (layoutTextProps, layoutSpacingProps, display, position, scrollY, backgroundColor, textAlignement, centerX, className) {
    if (position === void 0) { position = 'inherit'; }
    if (className === void 0) { className = ''; }
    return classNames('rck-layout', spacingClassNames$1(layoutSpacingProps), layoutTextClassNames$1(layoutTextProps), display ? "rck-layout--display-" + display : '', position !== 'inherit' ? "rck-layout--position-" + position : '', scrollY ? 'rck-layout--scroll-y' : '', backgroundColor ? "rck-layout--bck-color-" + backgroundColor : '', textAlignement ? "rck-layout--text-alignement-" + textAlignement : '', getCentered(centerX, position), className);
};
var layoutClassNames$1 = memoize(layoutClassNames);

var LayoutTest;
(function (LayoutTest) {
    LayoutTest["prefix"] = "Layout";
})(LayoutTest || (LayoutTest = {}));
var Layout = forwardRef(function (props, ref) {
    var display = props.display, position = props.position, left = props.left, right = props.right, top = props.top, bottom = props.bottom, marginLeft = props.marginLeft, marginRight = props.marginRight, marginTop = props.marginTop, marginBottom = props.marginBottom, paddingLeft = props.paddingLeft, paddingRight = props.paddingRight, paddingTop = props.paddingTop, paddingBottom = props.paddingBottom, margin = props.margin, padding = props.padding, minHeight = props.minHeight, minWidth = props.minWidth, maxHeight = props.maxHeight, maxWidth = props.maxWidth, width = props.width, height = props.height, noWrap = props.noWrap, lineHeight = props.lineHeight, scrollY = props.scrollY, centerX = props.centerX, backgroundColor = props.backgroundColor, _a = props.renderAs, Tag = _a === void 0 ? 'div' : _a, textAlignement = props.textAlignement, _b = props.className, className = _b === void 0 ? '' : _b, children = props.children, testId = props.testId;
    return (createElement(Tag, { ref: ref, style: {
            left: left,
            right: right,
            top: top,
            bottom: bottom,
        }, className: layoutClassNames$1({ lineHeight: lineHeight, noWrap: noWrap }, {
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight,
            marginTop: marginTop,
            paddingBottom: paddingBottom,
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            paddingTop: paddingTop,
            padding: padding,
            margin: margin,
            minHeight: minHeight,
            minWidth: minWidth,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            width: width,
            height: height,
        }, display, position, scrollY, backgroundColor, textAlignement, centerX, className), "data-testid": getTestId(LayoutTest.prefix, testId) }, children));
});
Layout.displayName = 'Layout';

var RibbonType;
(function (RibbonType) {
    RibbonType[RibbonType["cornerRight"] = 0] = "cornerRight";
    RibbonType[RibbonType["cornerLeft"] = 1] = "cornerLeft";
})(RibbonType || (RibbonType = {}));
var RibbonTest;
(function (RibbonTest) {
    RibbonTest["prefix"] = "Ribbon";
})(RibbonTest || (RibbonTest = {}));
var Ribbon = function (_a) {
    var _b;
    var type = _a.type, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId, children = _a.children;
    var ribbonTypeToString = (_b = {},
        _b[RibbonType.cornerRight] = 'corner-right',
        _b[RibbonType.cornerLeft] = 'corner-left',
        _b)[type];
    return (createElement("div", { className: classNames('rck-ribbon', "rck-ribbon--" + ribbonTypeToString, className), "data-testid": getTestId(RibbonTest.prefix, testId) },
        createElement("span", null, children)));
};
Ribbon.displayName = 'Ribbon';

var PlanBoxTest;
(function (PlanBoxTest) {
    PlanBoxTest["prefix"] = "PlanBox";
})(PlanBoxTest || (PlanBoxTest = {}));
var useIsBiggerThanSmallScreen = function () {
    return isTestEnv() ? false : reactMediaHook_2('(min-width: 768px)');
};
var PlanBox = function (_a) {
    var title = _a.title, price = _a.price, years = _a.years, priceAdditionalInformation = _a.priceAdditionalInformation, deviceInformation = _a.deviceInformation, _b = _a.highlighted, highlighted = _b === void 0 ? false : _b, _c = _a.hasDiscount, hasDiscount = _c === void 0 ? false : _c, current = _a.current, currentText = _a.currentText, ribbon = _a.ribbon, button = _a.button, carePlusInfo = _a.carePlusInfo, className = _a.className, testId = _a.testId;
    var biggerThanSmallScreen = useIsBiggerThanSmallScreen();
    var _d = useState(false), showCheckboxHelpInfo = _d[0], setShowCheckboxHelpInfo = _d[1];
    return (createElement("div", { className: classNames("rck-plan-box", current ? "rck-plan-box--current" : '', highlighted ? 'rck-plan-box--highlighted' : '', hasDiscount ? 'rck-plan-box--with-discount' : '', className || ''), "data-testid": getTestId(PlanBoxTest.prefix, testId) },
        (ribbon === null || ribbon === void 0 ? void 0 : ribbon.type) !== undefined && (ribbon === null || ribbon === void 0 ? void 0 : ribbon.text) ? (createElement(Ribbon, { type: ribbon.type }, ribbon.text)) : null,
        createElement(FlexLayout, { mainaxis: "column", display: "contents" },
            createElement(Fragment, null,
                createElement("div", { className: "rck-plan-box__body" },
                    createElement("h2", { className: "rck-plan-box__title" }, title),
                    createElement("div", { className: "rck-plan-box__price rck-plan-box__price-per-year-text" },
                        createElement(FlexLayout, { mainaxis: "row", crossaxisAlignment: "flex-end" },
                            createElement("span", { className: "price" }, price),
                            years ? createElement("span", { className: "price-period" },
                                "/",
                                years) : null)),
                    priceAdditionalInformation && (createElement("div", { className: "rck-plan-box__price-additional-information" }, priceAdditionalInformation))),
                createElement("div", { className: "rck-plan-box__device-information" },
                    createElement(FlexLayout, { mainaxis: "row", crossaxisAlignment: "center" },
                        createElement(FlexLayout, { mainaxis: "row", marginRight: "8" },
                            createElement(Icon$1, { type: IconType.phoneLaptop, size: IconSize.xs })),
                        createElement("span", null, deviceInformation))),
                carePlusInfo && (createElement("div", { className: "rck-plan-box__checkbox-container" },
                    createElement(FlexLayout, { mainaxis: "column" },
                        createElement(FlexLayout, { mainaxis: "row", mainaxisAlignment: "center" },
                            (carePlusInfo === null || carePlusInfo === void 0 ? void 0 : carePlusInfo.carePlusIncluded) ? (carePlusInfo === null || carePlusInfo === void 0 ? void 0 : carePlusInfo.label) : (createElement(Checkbox, { name: "test", label: carePlusInfo === null || carePlusInfo === void 0 ? void 0 : carePlusInfo.label, checked: carePlusInfo === null || carePlusInfo === void 0 ? void 0 : carePlusInfo.isChecked, onClick: carePlusInfo === null || carePlusInfo === void 0 ? void 0 : carePlusInfo.onClick })),
                            createElement(TransparentButton$1, { onClick: function () {
                                    return setShowCheckboxHelpInfo(!showCheckboxHelpInfo);
                                } },
                                createElement(Icon$1, { type: IconType.questionCircle, size: IconSize.regular }))),
                        createElement(AccordionMenu, { isVisible: showCheckboxHelpInfo },
                            createElement("p", { className: "rck-plan-box__checkbox-description" }, carePlusInfo === null || carePlusInfo === void 0 ? void 0 : carePlusInfo.description),
                            carePlusInfo.list))))),
            current ? (createElement("div", { className: "rck-plan-box__current-text" }, currentText)) : (createElement(Button$1, { loading: button.isLoading, disabled: button.isLoading, onClick: button.onClick, size: biggerThanSmallScreen ? ButtonSize.big : ButtonSize.medium, testId: testId, inverted: highlighted, block: true }, button.text)))));
};
PlanBox.displayName = 'PlanBox';

var RadioButtonTest;
(function (RadioButtonTest) {
    RadioButtonTest["prefix"] = "RadioButton";
})(RadioButtonTest || (RadioButtonTest = {}));
var RadioButton = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, name = _a.name, id = _a.id, checked = _a.checked, disabled = _a.disabled, block = _a.block, defaultChecked = _a.defaultChecked, value = _a.value, testId = _a.testId, onClick = _a.onClick, onBlur = _a.onBlur, onFocus = _a.onFocus, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onChange = _a.onChange;
    var handleOnClick = function () {
        if (!disabled) {
            if (onClick) {
                onClick(value);
            }
        }
    };
    return (createElement("label", { className: classNames(className, 'rck-radiobutton', block ? 'rck-radiobutton--block' : '', disabled ? 'rck-radiobutton--disabled' : ''), htmlFor: id, "data-testid": getTestId(RadioButtonTest.prefix, testId) },
        createElement("input", { id: id, className: "rck-radiobutton__input", name: name, type: "radio", checked: checked, defaultChecked: defaultChecked, onClick: handleOnClick, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onChange: onChange, value: value }),
        createElement("span", { className: classNames('rck-radiobutton__square', checked ? 'rck-radiobutton__square--checked' : '', disabled ? 'rck-radiobutton__square--disabled' : '') }, checked && (createElement(Icon$1, { family: IconFamily.solid, type: IconType.circle, className: classNames('rck-radiobutton__square__icon', disabled ? 'rck-radiobutton__square__icon--disabled' : ''), role: "presentation" })))));
};
RadioButton.displayName = 'RadioButton';

/* eslint-disable jsx-a11y/click-events-have-key-events */
var SideNavigationMenuTest;
(function (SideNavigationMenuTest) {
    SideNavigationMenuTest["prefix"] = "SideNavigationMenu";
    SideNavigationMenuTest["menuItem"] = "SideNavigationMenuItem";
    SideNavigationMenuTest["anchor"] = "SideNavigationMenuAnchor";
    SideNavigationMenuTest["extension"] = "SideNavigationMenuItemExtension";
    SideNavigationMenuTest["menuItemWrapper"] = "SideNavigationMenuItem-wrapper";
})(SideNavigationMenuTest || (SideNavigationMenuTest = {}));
var MenuItemExtension = React__default.memo(function (_a) {
    var title = _a.title, showBadge = _a.showBadge, showAccent = _a.showAccent, testId = _a.testId, parentTestId = _a.parentTestId;
    return (React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__extension", "data-testid": getTestId(SideNavigationMenuTest.extension, getTestIdWithParentTestId(parentTestId, testId)) },
        React__default.createElement("span", { className: "rck-side-navigation-menu__anchor__text" },
            title,
            showAccent && (React__default.createElement("span", { className: "rck-side-navigation-menu__accent" },
                React__default.createElement(Icon$1, { type: IconType.circle, family: IconFamily.solid, square: true })))),
        React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__optional-content" }, showBadge && (React__default.createElement(Badge$1, { className: "rck-side-navigation-menu__badge", type: BadgeType.contrast, text: "Premium", size: "small" })))));
});
var SideNavigationMenuAnchor = function (_a) {
    var item = _a.item, testId = _a.testId, parentTestId = _a.parentTestId;
    var Anchor = item.useAsLink;
    var _b = item.linkTo, linkTo = _b === void 0 ? '' : _b;
    return Anchor ? (React__default.createElement(Anchor, { className: classNames('rck-side-navigation-menu__anchor', item.isActive ? 'rck-side-navigation-menu__anchor--active' : ''), to: linkTo, "data-testid": getTestId(SideNavigationMenuTest.anchor, getTestIdWithParentTestId(parentTestId, testId)) },
        React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__content" },
            React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__content__activable" },
                React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__content__activable__layout" },
                    React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__icon" }, item.icon),
                    React__default.createElement(MenuItemExtension, { title: item.title, showBadge: item.showBadge, showAccent: item.showAccent, testId: testId, parentTestId: parentTestId })))))) : null;
};
var SideNavigationMenuItem = function (_a) {
    var item = _a.item, testId = _a.testId, parentTestId = _a.parentTestId;
    return (React__default.createElement("a", { className: classNames('rck-side-navigation-menu__anchor', item.isActive ? 'rck-side-navigation-menu__anchor--active' : ''), href: item.linkTo, "data-testid": getTestId(SideNavigationMenuTest.menuItem, getTestIdWithParentTestId(parentTestId, testId)) },
        React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__content" },
            React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__content__activable" },
                React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__content__activable__layout" },
                    React__default.createElement("div", { className: "rck-side-navigation-menu__anchor__icon" }, item.icon),
                    React__default.createElement(MenuItemExtension, { title: item.title, showBadge: item.showBadge, showAccent: item.showAccent, testId: testId, parentTestId: parentTestId }))))));
};
var SideNavigationMenu = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, accountInfo = _a.accountInfo, licenseInfo = _a.licenseInfo, testId = _a.testId, expand = _a.expand, items = _a.items;
    return (React__default.createElement("div", { className: classNames('rck-side-navigation-menu', className, expand ? 'rck-side-navigation-menu--expanded' : ''), "datatest-id": getTestId(SideNavigationMenuTest.prefix, testId) },
        React__default.cloneElement(accountInfo, {
            expand: expand,
        }),
        React__default.createElement("div", { className: "rck-side-navigation-menu__wrapper" },
            React__default.createElement(ScrollableContent, { hideScrollbar: true },
                React__default.createElement("ul", { className: "rck-side-navigation-menu__list" }, items.map(function (item) { return (React__default.createElement(React__default.Fragment, { key: item.key }, item.shouldShow && (React__default.createElement("li", { title: item.title, className: classNames('rck-side-navigation-menu__list__item'), onClick: item.onClick, role: "navigation", onKeyPress: item.onClick, "data-testid": getTestId(SideNavigationMenuTest.prefix, testId, SideNavigationMenuTest.menuItemWrapper, item.key) }, item.useAsLink ? (React__default.createElement(SideNavigationMenuAnchor, { item: item, testId: item.key, parentTestId: testId })) : (React__default.createElement(SideNavigationMenuItem, { item: item, testId: item.key, parentTestId: testId })))))); })))),
        licenseInfo));
};

var StepBarTest;
(function (StepBarTest) {
    StepBarTest["prefix"] = "StepBar";
})(StepBarTest || (StepBarTest = {}));
var StepBar = function (_a) {
    var _b = _a.activeStep, activeStep = _b === void 0 ? 0 : _b, hideLabels = _a.hideLabels, className = _a.className, steps = _a.steps, testId = _a.testId;
    return (createElement("div", { className: classNames("rck-stepbar", className || ''), "data-testid": getTestId(StepBarTest.prefix, testId) }, steps.map(function (step, key) {
        var currentStep = key + 1;
        var doneStepClass = key <= activeStep ? 'rck-step--done' : '';
        var activeStepClass = key === activeStep ? 'rck-step--active' : '';
        return (createElement("div", { className: classNames('rck-stepbar__step', 'rck-step', activeStepClass, doneStepClass), key: step, "data-testid": getTestId(StepBarTest.prefix, testId, step) },
            createElement("div", { className: "rck-step__label" },
                createElement("span", { className: "rck-step__label-title" },
                    ' ',
                    hideLabels ? '' : step,
                    ' ')),
            createElement("div", { className: "rck-step__circle" },
                createElement("span", null, currentStep))));
    })));
};
StepBar.displayName = 'Stepbar';

var SwitchTest;
(function (SwitchTest) {
    SwitchTest["prefix"] = "Switch";
    SwitchTest["actionElement"] = "Action-element";
})(SwitchTest || (SwitchTest = {}));
var Switch = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, id = _a.id, name = _a.name, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, testId = _a.testId, onClick = _a.onClick, onBlur = _a.onBlur, onFocus = _a.onFocus, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onChange = _a.onChange;
    var handleOnClick = function (ev) {
        if (!disabled) {
            if (onClick) {
                onClick(ev);
            }
        }
    };
    return (createElement("label", { htmlFor: id, className: classNames('rck-switch', disabled ? 'rck-switch--disabled' : '', className), "data-testid": getTestId(SwitchTest.prefix, testId) },
        createElement("input", { id: id, className: "rck-switch__input", name: name, type: "checkbox", checked: checked, disabled: disabled, onChange: onChange, onClick: handleOnClick, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseUp: onMouseUp, "data-testid": getTestId(SwitchTest.prefix, testId, SwitchTest.actionElement) }),
        createElement("span", { className: classNames('rck-switch__slider', disabled ? 'rck-switch__slider--disabled' : '') })));
};
Switch.displayName = 'Switch';

var InfoFieldLabelTest;
(function (InfoFieldLabelTest) {
    InfoFieldLabelTest["prefix"] = "InfoFieldLabel";
})(InfoFieldLabelTest || (InfoFieldLabelTest = {}));
var InfoFieldLabel = function (_a) {
    var htmlFor = _a.htmlFor, allowedLines = _a.allowedLines, _b = _a.mode, mode = _b === void 0 ? 'info' : _b, testId = _a.testId, _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children;
    return (createElement("div", { className: classNames('rck-info-field-label', className) }, children && (createElement("label", { htmlFor: htmlFor, className: classNames('rck-info-field-label__label', allowedLines
            ? "rck-info-field-label__label--lines-" + allowedLines
            : '', "rck-info-field-label__label--mode-" + mode), "data-testid": getTestId(InfoFieldLabelTest.prefix, testId) }, children))));
};
InfoFieldLabel.displayName = 'InfoFieldLabel';
var InfoFieldLabel$1 = memo(InfoFieldLabel);

var InputShowIconWhen;
(function (InputShowIconWhen) {
    InputShowIconWhen[InputShowIconWhen["always"] = 0] = "always";
    InputShowIconWhen[InputShowIconWhen["onError"] = 1] = "onError";
    InputShowIconWhen[InputShowIconWhen["edit"] = 2] = "edit";
})(InputShowIconWhen || (InputShowIconWhen = {}));
var GroupedInputTest;
(function (GroupedInputTest) {
    GroupedInputTest["prefix"] = "GroupedInput";
    GroupedInputTest["actionElement"] = "Action-element";
    GroupedInputTest["input"] = "Input";
})(GroupedInputTest || (GroupedInputTest = {}));
var isEditing = function (hasContent, hasFocus) {
    return hasContent && hasFocus;
};
var showIcon = function (hasContent, hasFocus, iconConfiguration, error) {
    return iconConfiguration &&
        ((iconConfiguration.showIconWhen === InputShowIconWhen.onError && error) ||
            iconConfiguration.showIconWhen === InputShowIconWhen.always ||
            (isEditing(hasContent, hasFocus) &&
                iconConfiguration.showIconWhen === InputShowIconWhen.edit));
};
var GroupedInput = function (_a) {
    var id = _a.id, value = _a.value, defaultValue = _a.defaultValue, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, type = _a.type, error = _a.error, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, iconConfiguration = _a.iconConfiguration, autoComplete = _a.autoComplete, autoCorrect = _a.autoCorrect, autoCapitalize = _a.autoCapitalize, spellCheck = _a.spellCheck, maxlength = _a.maxlength, minlength = _a.minlength, required = _a.required, min = _a.min, max = _a.max, pattern = _a.pattern, name = _a.name, iconLeft = _a.iconLeft, testId = _a.testId, onChange = _a.onChange, onBlur = _a.onBlur, onDragStart = _a.onDragStart, onFocus = _a.onFocus, onDrop = _a.onDrop, onIconClick = _a.onIconClick;
    var textInput = useRef(document.createElement('input'));
    var containerRef = useRef(document.createElement('div'));
    var _e = useState(false), isFocused = _e[0], setIsFocused = _e[1];
    var _f = useState(false), hasContent = _f[0], setHasContent = _f[1];
    var handleOnChange = function (ev) {
        setHasContent(textInput.current.value !== '');
        if (onChange) {
            onChange(ev, textInput.current.value);
        }
    };
    var handleOnIconClick = function (ev) {
        if ((iconConfiguration === null || iconConfiguration === void 0 ? void 0 : iconConfiguration.showIconWhen) === InputShowIconWhen.edit) {
            if (textInput !== null && textInput.current !== null) {
                textInput.current.value = '';
                handleOnChange(ev);
            }
        }
        if (onIconClick) {
            onIconClick(ev);
        }
    };
    var handleOnFocus = function (ev) {
        setIsFocused(true);
        setHasContent(textInput.current.value !== '');
        containerRef.current.classList.add('rck-text-field__grouped--focused');
        if (onFocus) {
            onFocus(ev);
        }
    };
    var handleOnBlur = function (ev) {
        setIsFocused(false);
        setHasContent(textInput.current.value !== '');
        containerRef.current.classList.remove('rck-text-field__grouped--focused');
        if (onBlur) {
            onBlur(ev);
        }
    };
    var onMouseEnterHandler = function () {
        containerRef.current.classList.add('rck-text-field__grouped--hover');
    };
    var onMouseLeaveHandler = function () {
        containerRef.current.classList.remove('rck-text-field__grouped--hover');
    };
    return (createElement("div", { className: classNames('rck-text-field__grouped', disabled ? 'rck-text-field__grouped--disabled' : ''), ref: containerRef, "data-testid": getTestId(GroupedInputTest.prefix, testId) },
        iconLeft && (createElement("span", { className: "rck-text-field__icon-left" },
            createElement("span", { className: "rck-text-field__icon__wrapper" }, iconLeft))),
        createElement("input", { id: id, value: value, defaultValue: defaultValue, disabled: disabled, type: type, placeholder: placeholder, onChange: handleOnChange, ref: textInput, className: classNames('rck-text-field__input', className, iconConfiguration ? 'rck-text-field__input--with-icon' : '', iconLeft ? 'rck-text-field__input--with-icon-left' : ''), name: name, autoComplete: autoComplete, autoCorrect: autoCorrect, autoCapitalize: autoCapitalize, spellCheck: spellCheck, maxLength: maxlength, minLength: minlength, required: required, min: min, max: max, pattern: pattern, "data-testid": getTestId(GroupedInputTest.prefix, testId, GroupedInputTest.input), onFocus: handleOnFocus, onBlur: handleOnBlur, onDragStart: onDragStart, onDrop: onDrop, onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler }),
        iconConfiguration && (createElement("span", { className: "rck-text-field__icon", onClick: handleOnIconClick, onKeyDown: handleOnIconClick, role: "button", tabIndex: 0, "data-testid": getTestId(GroupedInputTest.prefix, testId, GroupedInputTest.actionElement) },
            createElement("span", { className: classNames('rck-text-field__icon__wrapper', showIcon(hasContent, isFocused, iconConfiguration, error)
                    ? ''
                    : 'rck-text-field__icon__wrapper--hide') }, cloneElement(iconConfiguration.icon))))));
};
GroupedInput.displayName = 'GroupedInput';

var PasswordMode;
(function (PasswordMode) {
    PasswordMode[PasswordMode["none"] = 0] = "none";
    PasswordMode[PasswordMode["hide"] = 1] = "hide";
    PasswordMode[PasswordMode["show"] = 2] = "show";
})(PasswordMode || (PasswordMode = {}));
var TextFieldTest;
(function (TextFieldTest) {
    TextFieldTest["prefix"] = "TextField";
    TextFieldTest["supportText"] = "Support_content";
})(TextFieldTest || (TextFieldTest = {}));
var TextField = function (_a) {
    var id = _a.id, label = _a.label, _b = _a.className, className = _b === void 0 ? '' : _b, disabled = _a.disabled, block = _a.block, type = _a.type, error = _a.error, supportTextConfiguration = _a.supportTextConfiguration, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, autoComplete = _a.autoComplete, autoCorrect = _a.autoCorrect, autoCapitalize = _a.autoCapitalize, spellCheck = _a.spellCheck, maxlength = _a.maxlength, minlength = _a.minlength, required = _a.required, min = _a.min, max = _a.max, pattern = _a.pattern, name = _a.name, value = _a.value, defaultValue = _a.defaultValue, testId = _a.testId, canBeCleared = _a.canBeCleared, showAlertOnError = _a.showAlertOnError, iconLeft = _a.iconLeft, _d = _a.keepErrorLabelArea, keepErrorLabelArea = _d === void 0 ? true : _d, onIconClick = _a.onIconClick, onChange = _a.onChange, onBlur = _a.onBlur, onDragStart = _a.onDragStart, onFocus = _a.onFocus, onDrop = _a.onDrop;
    var _e = useState(PasswordMode.none), passwordMode = _e[0], setPasswordMode = _e[1];
    var handlePasswordModeChange = function (ev) {
        setPasswordMode(passwordMode === PasswordMode.show ? PasswordMode.hide : PasswordMode.show);
        if (onIconClick) {
            onIconClick(ev);
        }
    };
    var renderGroupedInput = function () {
        var otherProps = {
            id: id,
            disabled: disabled,
            className: className,
            placeholder: placeholder,
            defaultValue: defaultValue,
            error: error,
            autoComplete: autoComplete,
            autoCorrect: autoCorrect,
            autoCapitalize: autoCapitalize,
            spellCheck: spellCheck,
            maxlength: maxlength,
            minlength: minlength,
            required: required,
            min: min,
            max: max,
            pattern: pattern,
            iconLeft: iconLeft,
            name: name,
            onChange: onChange,
            onBlur: onBlur,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onFocus: onFocus,
            testId: testId,
        };
        if (type === 'password') {
            return (createElement(GroupedInput, __assign({ type: passwordMode === PasswordMode.show ? 'text' : 'password', iconConfiguration: {
                    showIconWhen: InputShowIconWhen.always,
                    icon: (createElement(Icon$1, { type: passwordMode === PasswordMode.show
                            ? IconType.eyeSlash
                            : IconType.eye })),
                }, onIconClick: handlePasswordModeChange }, otherProps)));
        }
        if (showAlertOnError && error) {
            return (createElement(GroupedInput, __assign({ type: type, iconConfiguration: {
                    showIconWhen: InputShowIconWhen.onError,
                    icon: (createElement(Icon$1, { family: IconFamily.regular, type: IconType.exclamationCircle })),
                }, value: value, onIconClick: onIconClick, onChange: onChange }, otherProps)));
        }
        return (createElement(GroupedInput, __assign({ type: type, iconConfiguration: canBeCleared
                ? {
                    showIconWhen: InputShowIconWhen.edit,
                    icon: (createElement(Icon$1, { family: IconFamily.regular, type: IconType.times })),
                }
                : undefined, value: value, onIconClick: onIconClick, onChange: onChange }, otherProps)));
    };
    return (createElement("div", { className: classNames('rck-text-field', block ? 'rck-text-field--block' : '', error ? 'rck-text-field--error' : '', disabled ? 'rck-text-field--disabled' : '', !keepErrorLabelArea ? 'rck-text-field--no-area-for-error' : '', className), "data-testid": getTestId(TextFieldTest.prefix, testId) },
        label ? (createElement("label", { htmlFor: name, className: "rck-text-field__label" }, label)) : null,
        renderGroupedInput(),
        supportTextConfiguration ? (createElement(InfoFieldLabel$1, { allowedLines: supportTextConfiguration.allowedLines, testId: name, htmlFor: name, mode: error ? 'error' : 'info' }, supportTextConfiguration.text)) : null));
};
TextField.displayName = 'TextField';

var StyledHeaderTest;
(function (StyledHeaderTest) {
    StyledHeaderTest["prefix"] = "StyledHeader";
})(StyledHeaderTest || (StyledHeaderTest = {}));
var StyledHeader = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'h1' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId, children = _a.children;
    var classes = classNames("rck-" + type, 'rck-styled-header', className);
    var dataTestId = getTestId(StyledHeaderTest.prefix, testId);
    switch (type) {
        case 'h1':
            return (React__default.createElement("h1", { className: classes, "data-testid": dataTestId }, children));
        case 'h2':
            return (React__default.createElement("h2", { className: classes, "data-testid": dataTestId }, children));
        case 'h3':
            return (React__default.createElement("h3", { className: classes, "data-testid": dataTestId }, children));
        case 'h4':
            return (React__default.createElement("h4", { className: classes, "data-testid": dataTestId }, children));
        case 'h5':
            return (React__default.createElement("h5", { className: classes, "data-testid": dataTestId }, children));
        default:
            return (React__default.createElement("h1", { className: classes, "data-testid": dataTestId }, children));
    }
};
var Header = React__default.memo(StyledHeader);

var BrandsHeaderTest;
(function (BrandsHeaderTest) {
    BrandsHeaderTest["prefix"] = "BrandsHeader";
})(BrandsHeaderTest || (BrandsHeaderTest = {}));
var StyledHeader$1 = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId, children = _a.children;
    var dataTestId = getTestId(BrandsHeaderTest.prefix, testId);
    return (React__default.createElement("div", { className: classNames('rck-brands-header', className), "data-testid": dataTestId }, children || (React__default.createElement(FlexLayout, { mainaxis: "row", mainaxisAlignment: "center" },
        React__default.createElement(Icon$1, { family: IconFamily.brands, type: IconType.windows, color: IconColor.primary, size: IconSize.lg }),
        React__default.createElement(Icon$1, { family: IconFamily.brands, type: IconType.apple, color: IconColor.primary, size: IconSize.lg }),
        React__default.createElement(Icon$1, { family: IconFamily.brands, type: IconType.chrome, color: IconColor.primary, size: IconSize.lg }),
        React__default.createElement(Icon$1, { family: IconFamily.brands, type: IconType.android, color: IconColor.primary, size: IconSize.lg })))));
};
var BrandsHeader = React__default.memo(StyledHeader$1);

var TextFieldAdapter = function (_a) {
    var label = _a.label, className = _a.className, disabled = _a.disabled, block = _a.block, type = _a.type, error = _a.error, supportTextConfiguration = _a.supportTextConfiguration, placeholder = _a.placeholder, autoComplete = _a.autoComplete, autoCorrect = _a.autoCorrect, autoCapitalize = _a.autoCapitalize, spellCheck = _a.spellCheck, maxlength = _a.maxlength, minlength = _a.minlength, required = _a.required, min = _a.min, max = _a.max, pattern = _a.pattern, defaultValue = _a.defaultValue, canBeCleared = _a.canBeCleared, showAlertOnError = _a.showAlertOnError, iconLeft = _a.iconLeft, meta = _a.meta, input = _a.input;
    return (createElement(TextField, __assign({ label: label, className: className, disabled: disabled, block: block, type: type, error: (!!(meta === null || meta === void 0 ? void 0 : meta.error) && (meta === null || meta === void 0 ? void 0 : meta.touched)) || error, supportTextConfiguration: (meta === null || meta === void 0 ? void 0 : meta.error) ? __assign({ text: meta === null || meta === void 0 ? void 0 : meta.error }, supportTextConfiguration) : supportTextConfiguration, placeholder: placeholder, autoComplete: autoComplete, autoCorrect: autoCorrect, autoCapitalize: autoCapitalize, spellCheck: spellCheck, maxlength: maxlength, minlength: minlength, required: required, min: min, max: max, pattern: pattern, defaultValue: defaultValue, canBeCleared: canBeCleared, showAlertOnError: showAlertOnError, iconLeft: iconLeft }, input)));
};
TextFieldAdapter.displayName = 'TextFieldAdapter';

var DropdownActionElementTest;
(function (DropdownActionElementTest) {
    DropdownActionElementTest["prefix"] = "DropdownActionElement";
})(DropdownActionElementTest || (DropdownActionElementTest = {}));
var DropdownActionElement = function (_a) {
    var text = _a.text, icon = _a.icon, iconRight = _a.iconRight, _b = _a.className, className = _b === void 0 ? '' : _b, disabled = _a.disabled, testId = _a.testId, onClick = _a.onClick;
    return (React__default.createElement("div", { className: classNames('rck-dropdown-action-name', disabled ? 'rck-dropdown-action-name--disabled' : '', className), onClick: onClick, onKeyDown: onClick, role: "button", tabIndex: 0, "data-testid": getTestId(DropdownActionElementTest.prefix, testId) },
        icon && React__default.createElement("span", { className: "rck-dropdown-action-name__icon" }, icon),
        React__default.createElement("span", { className: "rck-dropdown-action-name__text" }, text),
        iconRight && (React__default.createElement("span", { className: "rck-dropdown-action-name__icon rck-dropdown-action-name__icon--right" }, iconRight))));
};
DropdownActionElement.displayName = 'ActionElement';

var DropdownFooterTest;
(function (DropdownFooterTest) {
    DropdownFooterTest["prefix"] = "DropdownFooter";
})(DropdownFooterTest || (DropdownFooterTest = {}));
var DropdownFooter = function (_a) {
    var children = _a.children, onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId;
    return (React__default.createElement("ul", { role: "listbox", className: classNames('rck-dropdown__footer', className) },
        React__default.createElement("li", { onClick: onClick, role: "option", onKeyDown: onClick, "aria-selected": false, "data-testid": getTestId(DropdownFooterTest.prefix, testId) }, children)));
};
DropdownFooter.displayName = 'DropdownFooter';

var DropdownHeaderTest;
(function (DropdownHeaderTest) {
    DropdownHeaderTest["prefix"] = "DropdownHeader";
})(DropdownHeaderTest || (DropdownHeaderTest = {}));
var DropdownHeader = function (_a) {
    var children = _a.children, testId = _a.testId, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React__default.createElement("li", { className: classNames('rck-dropdown__list__header', className), "data-testid": getTestId(DropdownHeaderTest.prefix, testId) }, children));
};
DropdownHeader.displayName = 'DropdownHeader';

var DropdownOptionTest;
(function (DropdownOptionTest) {
    DropdownOptionTest["prefix"] = "DropdownOption";
})(DropdownOptionTest || (DropdownOptionTest = {}));
var DropdownOption = React__default.forwardRef(function (_a, ref) {
    var value = _a.value, text = _a.text, icon = _a.icon, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.showAsSelected, showAsSelected = _c === void 0 ? true : _c, selected = _a.selected, disabled = _a.disabled, active = _a.active, assignKey = _a.assignKey, showAssignKey = _a.showAssignKey, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, testId = _a.testId, children = _a.children;
    var handleClick = function () {
        if (!disabled && onClick) {
            onClick(value);
        }
    };
    var handleMouseEnter = function (ev) {
        if (onMouseEnter) {
            onMouseEnter(ev, value);
        }
    };
    var handleMouseLeave = function (ev) {
        if (onMouseLeave) {
            onMouseLeave(ev, value);
        }
    };
    var renderText = function () {
        if (active && !disabled) {
            return React__default.createElement("strong", null, text);
        }
        return text;
    };
    return (React__default.createElement("li", { className: classNames('rck-dropdown-option', active ? 'rck-dropdown-option--active' : '', showAsSelected && selected ? 'rck-dropdown-option--selected' : '', disabled ? 'rck-dropdown-option--disabled' : '', className), onClick: handleClick, onKeyDown: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, role: "option", "aria-selected": selected, ref: ref, "data-testid": getTestId(DropdownOptionTest.prefix, testId, value.toString()) },
        !children && icon && (React__default.createElement("span", { className: "rck-dropdown-option__icon" }, icon)),
        !children && (React__default.createElement("span", { className: "rck-dropdown-option__text" }, renderText())),
        !children && showAssignKey && assignKey && (React__default.createElement("span", { className: "rck-dropdown-option__key-assign" },
            "[ctrl+",
            assignKey,
            "]")),
        children));
});
DropdownOption.displayName = 'DropdownOption';

var useDetectOutsideClick = function (elements, initialState) {
    var _a = useState(initialState), isActive = _a[0], setInnerIsActive = _a[1];
    var _b = useState(initialState), prevIsActive = _b[0], setPrevIsActive = _b[1];
    var setIsActive = function (active) {
        if (active !== isActive) {
            setPrevIsActive(isActive);
        }
        setInnerIsActive(active);
    };
    useEffect(function () {
        var pageClickEvent = function (e) {
            if (!elements.some(function (el) { return el.current && el.current.contains(e.target); })) {
                setIsActive(false);
            }
        };
        if (isActive) {
            window.addEventListener('click', pageClickEvent);
        }
        return function () {
            window.removeEventListener('click', pageClickEvent);
        };
    }, [isActive, elements]);
    return [isActive, setIsActive, prevIsActive];
};

var usePortal = function (id, useSingleHook) {
    var rootElemRef = useRef(null);
    var uniqueId = 'portal-container';
    var getRootElem = function () {
        if (!rootElemRef.current) {
            rootElemRef.current = document.createElement('div');
            if (useSingleHook) {
                rootElemRef.current.setAttribute('name', uniqueId);
            }
        }
        return rootElemRef.current;
    };
    useEffect(function () {
        var _a;
        var parentElem = document.querySelector("#" + id);
        if (!parentElem && !isTestEnv)
            throw new Error('usePortal: Element to append for portal is invalid');
        var container = parentElem === null || parentElem === void 0 ? void 0 : parentElem.querySelector("[name=\"" + uniqueId + "\"]");
        if (!useSingleHook || (useSingleHook && !container)) {
            parentElem === null || parentElem === void 0 ? void 0 : parentElem.appendChild(getRootElem());
        }
        if (useSingleHook && !((_a = rootElemRef.current) === null || _a === void 0 ? void 0 : _a.parentElement)) {
            rootElemRef.current = container;
        }
        return function () {
            if (!useSingleHook) {
                getRootElem().remove();
            }
        };
    }, [id]);
    return getRootElem();
};

var FloatingMenuPlacement;
(function (FloatingMenuPlacement) {
    FloatingMenuPlacement["top"] = "top";
    FloatingMenuPlacement["bottom"] = "bottom";
})(FloatingMenuPlacement || (FloatingMenuPlacement = {}));
var useFloatingPlacement = function (el, initialPlacement, isActive, fixed) {
    var _a = useState(initialPlacement), placement = _a[0], setPlacement = _a[1];
    var updatePlacement = function (newPlacement) {
        if (el.current && isActive) {
            if (fixed && initialPlacement) {
                setPlacement(initialPlacement);
                return;
            }
            var dimensions = el.current.getBoundingClientRect();
            var totalHeight = window.innerHeight;
            var hasAvailableTopSpace = false;
            var hasAvailableBottomSpace = false;
            if (placement === FloatingMenuPlacement.bottom) {
                hasAvailableTopSpace = dimensions.top - dimensions.height > 0;
                hasAvailableBottomSpace =
                    dimensions.top + dimensions.height < totalHeight;
            }
            else {
                hasAvailableTopSpace = dimensions.bottom - dimensions.height > 0;
                hasAvailableBottomSpace =
                    dimensions.bottom + dimensions.height < totalHeight;
            }
            if (newPlacement && hasAvailableBottomSpace && hasAvailableTopSpace) {
                setPlacement(newPlacement);
            }
            else if (!hasAvailableBottomSpace && !hasAvailableTopSpace) {
                var availableSpaceTop = 0;
                var availableSpaceBottom = 0;
                if (placement === FloatingMenuPlacement.bottom) {
                    availableSpaceTop = dimensions.top;
                    availableSpaceBottom = totalHeight - dimensions.top;
                }
                else {
                    availableSpaceTop = dimensions.bottom;
                    availableSpaceBottom = totalHeight - dimensions.bottom;
                }
                if (availableSpaceBottom > availableSpaceTop &&
                    placement !== FloatingMenuPlacement.bottom) {
                    setPlacement(FloatingMenuPlacement.bottom);
                }
                else if (availableSpaceTop > availableSpaceBottom &&
                    placement !== FloatingMenuPlacement.top) {
                    setPlacement(FloatingMenuPlacement.top);
                }
            }
            else if (placement === FloatingMenuPlacement.bottom &&
                !hasAvailableBottomSpace) {
                setPlacement(FloatingMenuPlacement.top);
            }
            else if (placement === FloatingMenuPlacement.top &&
                !hasAvailableTopSpace) {
                setPlacement(FloatingMenuPlacement.bottom);
            }
        }
    };
    var updateAfterScroll = function () {
        updatePlacement();
    };
    useEffect(function () {
        document.addEventListener('scroll', updateAfterScroll);
        updatePlacement();
        return function () {
            document.removeEventListener('scroll', updateAfterScroll);
        };
    });
    useEffect(function () {
        updatePlacement(initialPlacement);
    }, [initialPlacement]);
    useEffect(function () {
        updatePlacement();
    }, [isActive]);
    return [placement, updatePlacement];
};

var DropdownElementOrientation;
(function (DropdownElementOrientation) {
    DropdownElementOrientation["notSet"] = "not-set";
    DropdownElementOrientation["left"] = "left";
    DropdownElementOrientation["right"] = "right";
    DropdownElementOrientation["center"] = "center";
})(DropdownElementOrientation || (DropdownElementOrientation = {}));
var DropdownAlignment;
(function (DropdownAlignment) {
    DropdownAlignment["top"] = "top";
    DropdownAlignment["center"] = "center";
    DropdownAlignment["bottom"] = "bottom";
})(DropdownAlignment || (DropdownAlignment = {}));
var Keys;
(function (Keys) {
    Keys["up"] = "ArrowUp";
    Keys["down"] = "ArrowDown";
    Keys["enter"] = "Enter";
})(Keys || (Keys = {}));

var useAttachedDomPosition = function (el, elToAttach, placement, actionElementPosition, marginFromAttached, initialTop, initialLeft) {
    var defaultPosition = { top: 0, left: 0 };
    // top already has margin: 8px;
    var defaultMarginTop = -8;
    var _a = useState({
        top: initialTop || defaultPosition.top,
        left: initialLeft || defaultPosition.left,
    }), actionElementDOMPosition = _a[0], setActionElementDOMPos = _a[1];
    var getLeft = function (left, right, widthActionEl) {
        if (actionElementPosition === DropdownElementOrientation.center) {
            var widthAttachedEl = elToAttach.current.getBoundingClientRect().width;
            var offset = Math.abs((widthAttachedEl - widthActionEl) / 2);
            return left - offset + window.scrollX;
        }
        return ((actionElementPosition === DropdownElementOrientation.right
            ? left
            : right) + window.scrollX);
    };
    var updateActionElementDOMPosition = function () {
        if (el && el.current && elToAttach && elToAttach.current) {
            var _a = el.current.getBoundingClientRect(), bottom = _a.bottom, right = _a.right, top_1 = _a.top, left = _a.left, widthActionEl = _a.width;
            var updatedDOMPos = {
                top: (placement === FloatingMenuPlacement.bottom
                    ? bottom - (marginFromAttached || defaultMarginTop)
                    : top_1 + (marginFromAttached || defaultMarginTop)) + window.scrollY,
                left: getLeft(left, right, widthActionEl),
            };
            setActionElementDOMPos({
                top: updatedDOMPos.top,
                left: updatedDOMPos.left,
            });
        }
    };
    useLayoutEffect(function () {
        window.addEventListener('resize', updateActionElementDOMPosition);
        window.addEventListener('scroll', updateActionElementDOMPosition, true);
        updateActionElementDOMPosition();
        return function () {
            window.removeEventListener('resize', updateActionElementDOMPosition);
            window.removeEventListener('scroll', updateActionElementDOMPosition);
        };
    }, [placement, actionElementPosition, elToAttach.current]);
    return [actionElementDOMPosition, updateActionElementDOMPosition];
};

var DropdownTest;
(function (DropdownTest) {
    DropdownTest["prefix"] = "Dropdown";
    DropdownTest["container"] = "Dropdown__container";
})(DropdownTest || (DropdownTest = {}));
var Dropdown = function (_a) {
    var _b;
    var actionElement = _a.actionElement, _c = _a.portalId, portalId = _c === void 0 ? 'portal-dropdown' : _c, useSinglePortalHook = _a.useSinglePortalHook, _d = _a.menuPlacement, menuPlacement = _d === void 0 ? FloatingMenuPlacement.bottom : _d, _e = _a.fixedMenuPlacement, fixedMenuPlacement = _e === void 0 ? false : _e, _f = _a.attachedMenuOriention, attachedMenuOriention = _f === void 0 ? DropdownElementOrientation.left : _f, _g = _a.showSelectedOption, showSelectedOption = _g === void 0 ? true : _g, id = _a.id, active = _a.active, _h = _a.className, className = _h === void 0 ? '' : _h, _j = _a.classNameList, classNameList = _j === void 0 ? '' : _j, disabled = _a.disabled, asModal = _a.asModal, header = _a.header, footer = _a.footer, testId = _a.testId, maxHeight = _a.maxHeight, maxWidth = _a.maxWidth, minWidth = _a.minWidth, _k = _a.showScrollbars, showScrollbars = _k === void 0 ? true : _k, alignment = _a.alignment, _l = _a.enableRemoveScroll, enableRemoveScroll = _l === void 0 ? true : _l, onChange = _a.onChange, onActiveChange = _a.onActiveChange, onClose = _a.onClose, onOpen = _a.onOpen, children = _a.children;
    var dropdownList = React__default.Children.toArray(children);
    var dropdownRef = useRef(document.createElement('ul'));
    var actionElementRef = useRef(document.createElement('div'));
    var activeOptionRef = useRef(document.createElement('li'));
    var containerRef = useRef(document.createElement('div'));
    var target = usePortal(portalId, useSinglePortalHook);
    var _m = useDetectOutsideClick([actionElementRef, containerRef], false), isActive = _m[0], setIsActive = _m[1], prevIsActive = _m[2];
    var placement = useFloatingPlacement(dropdownRef, menuPlacement, isActive, fixedMenuPlacement)[0];
    var _o = useState({
        ndx: 0,
        reason: 'unset',
    }), activeOption = _o[0], setActiveOption = _o[1];
    var _p = useState(false), isScrolling = _p[0], setIsScrolling = _p[1];
    var _q = useAttachedDomPosition(actionElementRef, dropdownRef, placement, attachedMenuOriention), actionElementDOMPosition = _q[0], updateActionElementDOMPosition = _q[1];
    var findIndexById = function (value) {
        return dropdownList.findIndex(function (child) { return child.props.value === value; });
    };
    var listStyles = {
        overflow: 'hidden',
        overflowY: 'auto',
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minWidth: minWidth,
    };
    var selected = dropdownList.length
        ? (_b = dropdownList.find(function (child) { return child.props.selected; })) === null || _b === void 0 ? void 0 : _b.props.value : undefined;
    var isActiveElementVisible = function () {
        return activeOptionRef.current.offsetTop > dropdownRef.current.scrollTop &&
            activeOptionRef.current.offsetTop <
                dropdownRef.current.scrollTop + dropdownRef.current.offsetHeight;
    };
    var startScrolling = function () {
        setIsScrolling(true);
        // Do not trigger onMouseEnter handler while is scrolling.
        setTimeout(function () {
            setIsScrolling(false);
        }, 200);
    };
    var handleScroll = function () {
        if (!isActive || !activeOptionRef.current || !dropdownRef.current)
            return;
        if (activeOption.reason === Keys.down && !isActiveElementVisible()) {
            startScrolling();
            dropdownRef.current.scrollTop += activeOptionRef.current.offsetHeight;
        }
        else if (activeOption.reason === Keys.up && !isActiveElementVisible()) {
            startScrolling();
            dropdownRef.current.scrollTop -= activeOptionRef.current.offsetHeight;
        }
    };
    var handleMouseEnterOption = function (ev, value) {
        if (!isActive || isScrolling)
            return;
        setActiveOption({ ndx: findIndexById(value), reason: 'cursor' });
    };
    var handleChange = function (value) {
        if (!dropdownList || disabled) {
            return;
        }
        setIsActive(false);
        if (onChange) {
            onChange(value);
        }
    };
    var handleKeydown = function (ev) {
        if (ev.key === Keys.down && activeOption.ndx < dropdownList.length - 1) {
            setActiveOption({ ndx: activeOption.ndx + 1, reason: ev.key });
        }
        if (ev.key === Keys.up && activeOption.ndx > 0) {
            setActiveOption({ ndx: activeOption.ndx - 1, reason: ev.key });
        }
        if (ev.key === Keys.enter) {
            var dropdownOption = dropdownList[activeOption.ndx];
            if (dropdownOption && !dropdownOption.props.disabled) {
                handleChange(dropdownOption.props.value);
            }
        }
        if (ev.ctrlKey) {
            var dropdownOption = dropdownList.find(function (child) { return child.props.assignKey === ev.key; });
            if (dropdownOption && !dropdownOption.props.disabled) {
                handleChange(dropdownOption.props.value);
            }
        }
    };
    var handleActionElementClick = function () {
        if (disabled) {
            return;
        }
        setIsActive(!isActive);
        if (!isActive) {
            setActiveOption({ ndx: 0, reason: 'unset' });
        }
    };
    useEffect(function () {
        handleScroll();
    }, [activeOption]);
    useEffect(function () {
        if (prevIsActive !== isActive) {
            if (onActiveChange) {
                onActiveChange(isActive);
            }
            if (!isActive && onClose) {
                onClose();
            }
            if (isActive && onOpen) {
                onOpen();
            }
        }
    }, [isActive, menuPlacement]);
    useEffect(function () {
        if (disabled) {
            setIsActive(false);
        }
    }, [disabled]);
    useEffect(function () {
        if (active === true && !isActive) {
            setIsActive(true);
        }
    }, [active]);
    useEffect(function () {
        document.addEventListener('keydown', handleKeydown);
        return function () {
            document.removeEventListener('keydown', handleKeydown);
        };
    });
    var renderActionElement = function () {
        var triggerClassNames = 'rck-dropdown__action-name-container';
        var sel = dropdownList.find(function (child) { return child.props.value === selected; });
        if (actionElement) {
            return React__default.createElement("div", { className: triggerClassNames }, actionElement);
        }
        return (React__default.createElement("div", { className: triggerClassNames },
            React__default.createElement(DropdownActionElement, { text: sel === null || sel === void 0 ? void 0 : sel.props.text, icon: sel === null || sel === void 0 ? void 0 : sel.props.icon, disabled: disabled })));
    };
    var getListStyles = function () {
        var _a = actionElementRef.current.getBoundingClientRect(), right = _a.right, left = _a.left;
        return __assign(__assign({}, listStyles), { minWidth: asModal ? '' : (minWidth || right - left) + "px", maxWidth: asModal ? '' : (maxWidth || right - left) + "px" });
    };
    var getList = function () {
        return !disabled && isActive && dropdownList.length ? (React__default.createElement("div", { className: classNames(asModal ? 'rck-dropdown__modal-overlay' : '') },
            React__default.createElement("div", { className: classNames('rck-dropdown-list-container', asModal ? 'rck-dropdown-list-container--modal' : '', classNameList), style: portalId && !asModal ? actionElementDOMPosition : {}, "data-testid": getTestId(DropdownTest.prefix, testId), ref: containerRef },
                React__default.createElement("ul", { ref: dropdownRef, className: classNames('rck-dropdown__list', "rck-dropdown__list--" + placement, "rck-dropdown__list--attached", "rck-dropdown__list--" + (asModal
                        ? DropdownElementOrientation.notSet
                        : attachedMenuOriention), !showScrollbars ? 'rck-dropdown__list--no-scrollbar' : ''), role: "listbox", style: getListStyles(), id: id },
                    header && (React__default.createElement(DropdownHeader, { testId: testId }, header)),
                    React__default.Children.map(children, function (child, ndx) {
                        var dropdownOption = child;
                        if (dropdownOption === null) {
                            return null;
                        }
                        if (dropdownOption.type !== DropdownOption) {
                            throw new Error('Dropdown must contain DropdownOptions');
                        }
                        if (dropdownOption.props.value === selected && !actionElement) {
                            return null;
                        }
                        return React__default.cloneElement(dropdownOption, {
                            onClick: function (value) {
                                if (dropdownOption.props.onClick) {
                                    dropdownOption.props.onClick(value);
                                }
                                handleChange(value);
                            },
                            selected: dropdownOption.props.value === selected,
                            onMouseEnter: handleMouseEnterOption,
                            active: ndx === activeOption.ndx,
                            ref: ndx === activeOption.ndx ? activeOptionRef : undefined,
                            showAsSelected: showSelectedOption,
                            testId: testId,
                        });
                    })),
                footer && (React__default.createElement(DropdownFooter, { onClick: handleActionElementClick, testId: testId }, footer))))) : null;
    };
    var getListWithRemoveScroll = function () {
        var list = getList();
        return list ? React__default.createElement(RemoveScroll, null, list) : null;
    };
    return (React__default.createElement("div", { className: classNames('rck-dropdown', alignment ? "rck-dropdown--" + alignment : '', className), "data-testid": getTestId(DropdownTest.prefix, testId, DropdownTest.container) },
        React__default.cloneElement(renderActionElement(), {
            onClick: function () {
                updateActionElementDOMPosition();
                handleActionElementClick();
            },
            ref: actionElementRef,
        }),
        portalId &&
            target &&
            ReactDOM__default.createPortal(enableRemoveScroll ? getListWithRemoveScroll() : getList(), target)));
};
Dropdown.displayName = 'Dropdown';

var useElementDisable = function (el, disable, disableClass, overlapClass) {
    var createOverlap = function () {
        var div = document.createElement('div');
        div.className = overlapClass;
        return div;
    };
    useEffect(function () {
        if (el && el.current) {
            if (disable && !el.current.classList.contains(disableClass)) {
                el.current.classList.add(disableClass);
                if (el.current.prepend) {
                    el.current.prepend(createOverlap());
                }
            }
            if (!disable && el.current.classList.contains(disableClass)) {
                el.current.classList.remove(disableClass);
                var overlap = el.current.querySelector("." + overlapClass);
                if (overlap) {
                    el.current.removeChild(overlap);
                }
            }
        }
    }, [disable]);
};

var QuoteTest;
(function (QuoteTest) {
    QuoteTest["prefix"] = "Quote";
})(QuoteTest || (QuoteTest = {}));
var Quote = function (_a) {
    var _b = _a.maxLines, maxLines = _b === void 0 ? 'one' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId, children = _a.children;
    return (React__default.createElement("div", { className: classNames('rck-quote', "rck-quote--" + maxLines, className), "data-testid": getTestId(QuoteTest.prefix, testId) },
        React__default.createElement("i", null, children)));
};
Quote.displayName = 'Quote';
var Quote$1 = React__default.memo(Quote);

var IconAdapter = function (_a) {
    var icon = _a.icon, className = _a.className, altText = _a.altText;
    if (typeof icon === 'string') {
        return (createElement("img", { className: className, src: icon, role: "presentation", alt: altText }));
    }
    return icon;
};
IconAdapter.displayName = 'IconAdapter';
var IconAdapter$1 = memo(IconAdapter);

var ListItemVerticalAlign;
(function (ListItemVerticalAlign) {
    ListItemVerticalAlign["top"] = "top";
    ListItemVerticalAlign["center"] = "center";
    ListItemVerticalAlign["bottom"] = "bottom";
})(ListItemVerticalAlign || (ListItemVerticalAlign = {}));
var ListItemTopPadding;
(function (ListItemTopPadding) {
    ListItemTopPadding["none"] = "padding-none";
    ListItemTopPadding["short"] = "padding-s";
    ListItemTopPadding["medium"] = "padding-m";
    ListItemTopPadding["large"] = "padding-l";
})(ListItemTopPadding || (ListItemTopPadding = {}));

var ListSubtitleTest;
(function (ListSubtitleTest) {
    ListSubtitleTest["prefix"] = "ListSubtitle";
})(ListSubtitleTest || (ListSubtitleTest = {}));
var ListSubtitle = function (_a) {
    var _b = _a.align, align = _b === void 0 ? TextAlign.left : _b, _c = _a.fontSize, fontSize = _c === void 0 ? 's' : _c, _d = _a.color, color = _d === void 0 ? 'neutral' : _d, allowLines = _a.allowLines, _e = _a.renderAs, Tag = _e === void 0 ? 'p' : _e, children = _a.children, _f = _a.className, className = _f === void 0 ? '' : _f, testId = _a.testId, parentTestId = _a.parentTestId;
    return (React__default.createElement(Tag, { className: classNames("rck-list-subtitle", "rck-list-subtitle--align-" + align, "rck-list-subtitle--fsize-" + fontSize, allowLines ? "rck-list-subtitle--ellipsis-for-" + allowLines : '', "rck-list-subtitle--" + color, className), "data-testid": getTestId(ListSubtitleTest.prefix, getTestIdWithParentTestId(parentTestId, testId)) }, children));
};
ListSubtitle.displayName = 'ListSubtitle';
var ListSubtitle$1 = React__default.memo(ListSubtitle);

var ListTitleTest;
(function (ListTitleTest) {
    ListTitleTest["prefix"] = "ListTitle";
})(ListTitleTest || (ListTitleTest = {}));
var ListTitle = function (_a) {
    var _b = _a.align, align = _b === void 0 ? TextAlign.left : _b, allowLines = _a.allowLines, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId, parentTestId = _a.parentTestId, _d = _a.isBold, isBold = _d === void 0 ? true : _d, _e = _a.renderAs, Tag = _e === void 0 ? 'p' : _e;
    return (React__default.createElement(Tag, { className: classNames('rck-list-title', "rck-list-title--align-" + align, allowLines ? "rck-list-title--ellipsis-for-" + allowLines : '', className), "data-testid": getTestId(ListTitleTest.prefix, getTestIdWithParentTestId(parentTestId, testId)) }, isBold ? React__default.createElement("strong", null, children) : children));
};
ListTitle.displayName = 'ListTitle';
var ListTitle$1 = React__default.memo(ListTitle);

var ActivityStyleListItemTest;
(function (ActivityStyleListItemTest) {
    ActivityStyleListItemTest["prefix"] = "ListItem";
    ActivityStyleListItemTest["actionElement"] = "Action-element";
})(ActivityStyleListItemTest || (ActivityStyleListItemTest = {}));
var ActivityStyleListItem = function (_a) {
    var icon = _a.icon, iconAltText = _a.iconAltText, title = _a.title, upperSubtitle = _a.upperSubtitle, lowerSubtitle = _a.lowerSubtitle, rightText = _a.rightText, badges = _a.badges, quoteText = _a.quoteText, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId, parentTestId = _a.parentTestId, actionElement = _a.actionElement, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var listItemRef = useRef(document.createElement('li'));
    useElementDisable(listItemRef, disabled, 'rck-list-item--disabled', 'rck-list-item__overlap');
    return (React__default.createElement("li", { className: classNames('rck-list-item', "rck-list-item--" + ListItemTopPadding.large, "rck-activity-list-item", className), "data-testid": getTestId(ActivityStyleListItemTest.prefix, getTestIdWithParentTestId(parentTestId, testId)), ref: listItemRef },
        React__default.createElement("div", { className: "rck-activity-list-item__left" },
            React__default.createElement(IconAdapter$1, { icon: icon, altText: iconAltText })),
        React__default.createElement("div", { className: "rck-activity-list-item__middle-left" },
            upperSubtitle &&
                (typeof upperSubtitle === 'string' ? (React__default.createElement(ListSubtitle$1, { className: "rck-activity-list-item__middle-left__subtitle", parentTestId: parentTestId, testId: testId }, upperSubtitle)) : (React__default.cloneElement(upperSubtitle, {
                    className: 'rck-activity-list-item__middle-left__subtitle',
                }))),
            typeof title === 'string' ? (React__default.createElement(ListTitle$1, { className: "rck-activity-list-item__middle-left__title", parentTestId: parentTestId, testId: testId }, title)) : (React__default.cloneElement(title, {
                className: 'rck-activity-list-item__middle-left__title',
            })),
            badges && badges.length && (React__default.createElement("div", null, React__default.Children.map(badges, function (child) {
                var badge = child;
                if (badge === null) {
                    return null;
                }
                if (badge.type !== Badge$1) {
                    throw new Error('Activity list item badge just allow Badge components');
                }
                return badge;
            }))),
            lowerSubtitle &&
                (typeof lowerSubtitle === 'string' ? (React__default.createElement(ListSubtitle$1, { className: "rck-activity-list-item__middle-left__subtitle", parentTestId: parentTestId, testId: testId }, lowerSubtitle)) : (React__default.cloneElement(lowerSubtitle, {
                    className: 'rck-activity-list-item__middle-left__subtitle',
                }))),
            quoteText && (React__default.createElement(Quote$1, { className: "rck-activity-list-item__middle-left__quote", testId: getTestIdWithParentTestId(parentTestId, testId) }, quoteText))),
        React__default.createElement("div", { className: "rck-activity-list-item__right" },
            rightText && (React__default.createElement("p", { className: "rck-activity-list-item__right__text" }, rightText)),
            actionElement && (React__default.createElement("div", { className: "rck-activity-list-item__right__action-element", "data-testid": getTestId(ActivityStyleListItemTest.prefix, parentTestId, testId, ActivityStyleListItemTest.actionElement) }, actionElement)))));
};
ActivityStyleListItem.displayName = 'ActivityStyleListItem';

var ListCompactRightSubtitleTest;
(function (ListCompactRightSubtitleTest) {
    ListCompactRightSubtitleTest["prefix"] = "ListCompactRightSubtitle";
})(ListCompactRightSubtitleTest || (ListCompactRightSubtitleTest = {}));
var ListCompactRightSubtitle = function (_a) {
    var testId = _a.testId, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children;
    return (React__default.createElement("p", { className: classNames('rck-list-compact-right-subtitle', className), "data-testid": testId }, children));
};
ListCompactRightSubtitle.displayName = 'ListCompactRightSubtitle';
var ListCompactRightSubtitle$1 = React__default.memo(ListCompactRightSubtitle);

var ListCompactSubtitleTest;
(function (ListCompactSubtitleTest) {
    ListCompactSubtitleTest["prefix"] = "ListCompactSubtitle";
})(ListCompactSubtitleTest || (ListCompactSubtitleTest = {}));
var ListCompactSubtitle = function (_a) {
    var testId = _a.testId, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children;
    return (React__default.createElement("p", { className: classNames('rck-list-compact-subtitle', className), "data-testid": testId }, children));
};
ListCompactSubtitle.displayName = 'ListCompactSubtitle';
var ListCompactSubtitle$1 = React__default.memo(ListCompactSubtitle);

var ListCompactTitleTest;
(function (ListCompactTitleTest) {
    ListCompactTitleTest["prefix"] = "ListCompactTitle";
})(ListCompactTitleTest || (ListCompactTitleTest = {}));
var ListCompactTitle = function (_a) {
    var testId = _a.testId, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children;
    return (React__default.createElement("p", { className: classNames('rck-list-compact-title', className), "data-testid": testId }, children));
};
ListCompactTitle.displayName = 'ListCompactTitle';
var ListCompactTitle$1 = React__default.memo(ListCompactTitle);

var CompactStyleListItemTest;
(function (CompactStyleListItemTest) {
    CompactStyleListItemTest["prefix"] = "ListItem";
    CompactStyleListItemTest["title"] = "Title-content";
    CompactStyleListItemTest["rightTitle"] = "Title-right-content";
    CompactStyleListItemTest["subtitle"] = "Subtitle-content";
    CompactStyleListItemTest["rightSubtitle"] = "Subtitle-right-content";
})(CompactStyleListItemTest || (CompactStyleListItemTest = {}));
var CompactStyleListItem = function (_a) {
    var className = _a.className, title = _a.title, subtitle = _a.subtitle, subtitleClassName = _a.subtitleClassName, rightTitle = _a.rightTitle, rightSubtitle = _a.rightSubtitle, extraRightSpace = _a.extraRightSpace, icon = _a.icon, iconAltText = _a.iconAltText, _b = _a.bottomPadding, bottomPadding = _b === void 0 ? 'compact' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, testId = _a.testId, parentTestId = _a.parentTestId;
    var listItemRef = useRef(document.createElement('li'));
    useElementDisable(listItemRef, disabled, 'rck-list-item--disabled', 'rck-list-item__overlap');
    return (React__default.createElement("li", { className: classNames('rck-list-item', 'rck-compact-list-item', "rck-compact-list-item--padding-b-" + bottomPadding, className || ''), "data-testid": getTestId(CompactStyleListItemTest.prefix, getTestIdWithParentTestId(parentTestId, testId)), ref: listItemRef },
        icon && (React__default.createElement("div", { className: "rck-compact-list-item__icon-wrapper" },
            React__default.createElement(IconAdapter$1, { icon: icon, altText: iconAltText, className: "rck-compact-list-item__icon" }))),
        React__default.createElement("div", { className: "rck-compact-list-item__content" }, !rightTitle && !subtitle ? (React__default.createElement("div", { className: "rck-compact-list-item__one-line-content" },
            typeof title === 'string' ? (React__default.createElement(ListCompactTitle$1, { className: "rck-compact-list-item__title", testId: getTestId(CompactStyleListItemTest.title, getTestIdWithParentTestId(parentTestId, testId)) }, title)) : (React__default.cloneElement(title, {
                className: classNames('rck-compact-list-item__title', extraRightSpace ? 'rck-compact-list-item__title--small' : ''),
                testId: getTestId(CompactStyleListItemTest.title, getTestIdWithParentTestId(parentTestId, testId)),
            })),
            rightSubtitle &&
                (typeof rightSubtitle === 'string' ? (React__default.createElement(ListCompactRightSubtitle$1, { className: "rck-compact-list-item__right-subtitle", testId: getTestId(CompactStyleListItemTest.rightSubtitle, getTestIdWithParentTestId(parentTestId, testId)) }, rightSubtitle)) : (React__default.cloneElement(rightSubtitle, {
                    className: 'rck-compact-list-item__right-subtitle',
                    testId: getTestId(CompactStyleListItemTest.rightSubtitle, getTestIdWithParentTestId(parentTestId, testId)),
                }))))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { className: "rck-compact-list-item__top-content" },
                title &&
                    (typeof title === 'string' ? (React__default.createElement(ListCompactTitle$1, { className: classNames('rck-compact-list-item__title', extraRightSpace
                            ? 'rck-compact-list-item__title--small'
                            : ''), testId: getTestId(CompactStyleListItemTest.title, getTestIdWithParentTestId(parentTestId, testId)) }, title)) : (React__default.cloneElement(title, {
                        className: classNames('rck-compact-list-item__title', extraRightSpace
                            ? 'rck-compact-list-item__title--small'
                            : ''),
                        testId: getTestId(CompactStyleListItemTest.title, getTestIdWithParentTestId(parentTestId, testId)),
                    }))),
                rightTitle &&
                    (typeof rightTitle === 'string' ? (React__default.createElement(ListCompactRightSubtitle$1, { className: "rck-compact-list-item__right-title", testId: getTestId(CompactStyleListItemTest.rightTitle, getTestIdWithParentTestId(parentTestId, testId)) }, rightTitle)) : (React__default.cloneElement(rightTitle, {
                        className: 'rck-compact-list-item__right-title',
                        testId: getTestId(CompactStyleListItemTest.rightTitle, getTestIdWithParentTestId(parentTestId, testId)),
                    })))),
            React__default.createElement("div", { className: "rck-compact-list-item__bottom-content" },
                subtitle &&
                    (typeof subtitle === 'string' ? (React__default.createElement(ListCompactSubtitle$1, { className: classNames('rck-compact-list-item__subtitle', extraRightSpace
                            ? 'rck-compact-list-item__subtitle--small'
                            : '', subtitleClassName || ''), testId: getTestId(CompactStyleListItemTest.subtitle, getTestIdWithParentTestId(parentTestId, testId)) }, subtitle)) : (React__default.cloneElement(subtitle, {
                        className: classNames('rck-compact-list-item__subtitle', extraRightSpace
                            ? 'rck-compact-list-item__subtitle--small'
                            : '', subtitleClassName || ''),
                        testId: getTestId(CompactStyleListItemTest.subtitle, getTestIdWithParentTestId(parentTestId, testId)),
                    }))),
                rightSubtitle &&
                    (typeof rightSubtitle === 'string' ? (React__default.createElement(ListCompactRightSubtitle$1, { className: "rck-compact-list-item__right-subtitle", testId: getTestId(CompactStyleListItemTest.rightSubtitle, getTestIdWithParentTestId(parentTestId, testId)) }, rightSubtitle)) : (React__default.cloneElement(rightSubtitle, {
                        className: 'rck-compact-list-item__right-subtitle',
                        testId: getTestId(CompactStyleListItemTest.rightSubtitle, getTestIdWithParentTestId(parentTestId, testId)),
                    })))))))));
};
CompactStyleListItem.displayName = 'CompactStyleListItem';

var CustomStyleListItemTest;
(function (CustomStyleListItemTest) {
    CustomStyleListItemTest["prefix"] = "ListItem";
})(CustomStyleListItemTest || (CustomStyleListItemTest = {}));
var CustomStyleListItem = function (_a) {
    var className = _a.className, title = _a.title, icon = _a.icon, iconAltText = _a.iconAltText, children = _a.children, rightContent = _a.rightContent, footerContent = _a.footerContent, showSeparator = _a.showSeparator, _b = _a.disabled, disabled = _b === void 0 ? false : _b, testId = _a.testId, parentTestId = _a.parentTestId;
    var listItemRef = useRef(document.createElement('li'));
    useElementDisable(listItemRef, disabled, 'rck-list-item--disabled', 'rck-list-item__overlap');
    return (React__default.createElement("li", { className: classNames('rck-list-item', 'rck-custom-list-item', showSeparator ? '' : 'rck-custom-list-item--no-border', className || ''), "data-testid": getTestId(CustomStyleListItemTest.prefix, getTestIdWithParentTestId(parentTestId, testId)), ref: listItemRef },
        React__default.createElement("div", { className: "rck-custom-list-item__body" },
            React__default.createElement("div", { className: "rck-custom-list-item__body__left" },
                React__default.createElement("div", { className: "rck-custom-list-item__body__left__icon" },
                    React__default.createElement(IconAdapter$1, { icon: icon, altText: iconAltText }))),
            React__default.createElement("div", { className: "rck-custom-list-item__body__middle-left" },
                typeof title === 'string' ? (React__default.createElement(ListTitle$1, { className: "rck-custom-list-item__body__middle-left__title", testId: testId, parentTestId: parentTestId }, title)) : (React__default.cloneElement(title, {
                    className: 'rck-custom-list-item__body__middle-left__title',
                })),
                React__default.createElement("div", { className: "rck-custom-list-item__body__middle-left__content" }, children)),
            rightContent && (React__default.createElement("div", { className: "rck-custom-list-item__body__right" }, rightContent))),
        footerContent && (React__default.createElement("div", { className: "rck-custom-list-item__footer" }, footerContent))));
};
CustomStyleListItem.displayName = 'CustomStyleListItem';

var FreeStyleListItemTest;
(function (FreeStyleListItemTest) {
    FreeStyleListItemTest["prefix"] = "ListItem";
})(FreeStyleListItemTest || (FreeStyleListItemTest = {}));
var FreeStyleListItem = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, testId = _a.testId, _c = _a.disabled, disabled = _c === void 0 ? false : _c, parentTestId = _a.parentTestId;
    var listItemRef = useRef(document.createElement('li'));
    useElementDisable(listItemRef, disabled, 'rck-list-item--disabled', 'rck-list-item__overlap');
    return (React__default.createElement("li", { className: classNames("rck-list-item", 'rck-free-list-item', className), "data-testid": getTestId(FreeStyleListItemTest.prefix, getTestIdWithParentTestId(parentTestId, testId)), ref: listItemRef }, children));
};
FreeStyleListItem.displayName = 'FreeStyleListItem';

var LocationStyleListItemTest;
(function (LocationStyleListItemTest) {
    LocationStyleListItemTest["prefix"] = "ListItem";
})(LocationStyleListItemTest || (LocationStyleListItemTest = {}));
var LocationStyleListItem = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, leftSubtitle = _a.leftSubtitle, upperTitle = _a.upperTitle, lowerTitle = _a.lowerTitle, _c = _a.wideLeftSubtitle, wideLeftSubtitle = _c === void 0 ? false : _c, showActions = _a.showActions, actions = _a.actions, children = _a.children, testId = _a.testId, _d = _a.disabled, disabled = _d === void 0 ? false : _d, parentTestId = _a.parentTestId;
    var listItemRef = useRef(document.createElement('li'));
    useElementDisable(listItemRef, disabled, 'rck-list-item--disabled', 'rck-list-item__overlap');
    return (React__default.createElement("li", { className: classNames("rck-list-item", 'rck-location-list-item', wideLeftSubtitle ? 'rck-location-list-item--wide' : '', className), "data-testid": getTestId(LocationStyleListItemTest.prefix, getTestIdWithParentTestId(parentTestId, testId)), ref: listItemRef },
        React__default.createElement("div", { className: "rck-location-list-item__left" },
            React__default.createElement("div", { className: "rck-location-list-item__left__text" }, typeof leftSubtitle === 'string' ? (React__default.createElement(ListSubtitle$1, { align: TextAlign.right, fontSize: "medium", testId: testId, parentTestId: parentTestId }, leftSubtitle)) : (React__default.cloneElement(leftSubtitle, {
                align: TextAlign.right,
                fontSize: 'medium',
            }))),
            React__default.createElement("div", { className: "rck-location-list-item__left__oval" })),
        React__default.createElement("div", { className: "rck-location-list-item__middle-left" },
            !children &&
                upperTitle &&
                (typeof upperTitle === 'string' ? (React__default.createElement(ListTitle$1, { className: "rck-location-list__middle-left__text", testId: testId, parentTestId: parentTestId }, upperTitle)) : (React__default.cloneElement(upperTitle, {
                    className: 'rck-location-list__middle-left__text',
                }))),
            !children &&
                lowerTitle &&
                (typeof lowerTitle === 'string' ? (React__default.createElement(ListTitle$1, { className: "rck-location-list__middle-left__text", testId: testId, parentTestId: parentTestId }, lowerTitle)) : (React__default.cloneElement(lowerTitle, {
                    className: 'rck-location-list__middle-left__text',
                }))),
            React__default.createElement("div", { className: classNames('rck-location-list-item__actions', showActions ? 'rck-location-list-item__actions--visible' : '') }, !children && actions),
            children)));
};
LocationStyleListItem.displayName = 'LocationStyleListItem';

var RegularStyleListItemTest;
(function (RegularStyleListItemTest) {
    RegularStyleListItemTest["prefix"] = "ListItem";
    RegularStyleListItemTest["actionElement"] = "Action-element";
})(RegularStyleListItemTest || (RegularStyleListItemTest = {}));
var RegularStyleListItem = function (_a) {
    var icon = _a.icon, iconAltText = _a.iconAltText, _b = _a.iconVerticalAlign, iconVerticalAlign = _b === void 0 ? ListItemVerticalAlign.center : _b, title = _a.title, upperSubtitle = _a.upperSubtitle, lowerSubtitle = _a.lowerSubtitle, centerMiddleContent = _a.centerMiddleContent, _c = _a.className, className = _c === void 0 ? '' : _c, actionElement = _a.actionElement, _d = _a.actionElementVerticalAlign, actionElementVerticalAlign = _d === void 0 ? ListItemVerticalAlign.center : _d, testId = _a.testId, _e = _a.disabled, disabled = _e === void 0 ? false : _e, parentTestId = _a.parentTestId;
    var listItemRef = useRef(document.createElement('li'));
    useElementDisable(listItemRef, disabled, 'rck-list-item--disabled', 'rck-list-item__overlap');
    return (React__default.createElement("li", { className: classNames('rck-list-item', "rck-regular-list-item", className), "data-testid": getTestId(RegularStyleListItemTest.prefix, getTestIdWithParentTestId(parentTestId, testId)), ref: listItemRef },
        icon && (React__default.createElement("div", { className: classNames('rck-regular-list-item__left', "rck-regular-list-item__left--" + iconVerticalAlign) },
            React__default.createElement("div", { className: "rck-regular-list-item__left__icon" },
                React__default.createElement(IconAdapter$1, { icon: icon, altText: iconAltText })))),
        React__default.createElement("div", { className: classNames('rck-regular-list-item__middle-left', centerMiddleContent
                ? 'rck-regular-list-item__middle-left--centered'
                : '') },
            title &&
                (typeof title === 'string' ? (React__default.createElement(ListTitle$1, { className: "rck-regular-list-item__middle-left__title", testId: testId, parentTestId: parentTestId }, title)) : (React__default.cloneElement(title, {
                    className: 'rck-regular-list-item__middle-left__title',
                    isBold: false,
                }))),
            upperSubtitle &&
                (typeof upperSubtitle === 'string' ? (React__default.createElement(ListSubtitle$1, { className: "rck-regular-list-item__middle-left__subtitle", testId: testId, parentTestId: parentTestId }, upperSubtitle)) : (React__default.cloneElement(upperSubtitle, {
                    className: 'rck-regular-list-item__middle-left__subtitle',
                }))),
            lowerSubtitle &&
                (typeof lowerSubtitle === 'string' ? (React__default.createElement(ListSubtitle$1, { className: "rck-regular-list-item__middle-left__subtitle", testId: testId, parentTestId: parentTestId }, lowerSubtitle)) : (React__default.cloneElement(lowerSubtitle, {
                    className: 'rck-regular-list-item__middle-left__subtitle',
                })))),
        actionElement && (React__default.createElement("div", { className: classNames('rck-regular-list-item__right', "rck-regular-list-item__right--" + actionElementVerticalAlign) },
            React__default.createElement("div", { className: "rck-regular-list-item__right__action-element", "data-testid": getTestId(RegularStyleListItemTest.prefix, getTestIdWithParentTestId(parentTestId, testId), RegularStyleListItemTest.actionElement) }, actionElement)))));
};
RegularStyleListItem.displayName = 'RegularStyleListItem';

var listClassNames = function (showSeparator, listItemPaddingTop, listItemPaddingBottom, listItemPaddingRight, listItemPaddingLeft, listItemMarginTop, listItemMarginBottom, columns, horizontalOrientation, allowWrapping, useNativeColumns, className) {
    if (className === void 0) { className = ''; }
    return classNames('rck-list', showSeparator ? '' : "rck-list--no-separator", listItemPaddingTop
        ? "rck-list--item-top-padding-spacing-" + listItemPaddingTop
        : '', listItemPaddingBottom
        ? "rck-list--item-bottom-padding-spacing-" + listItemPaddingBottom
        : '', listItemPaddingRight
        ? "rck-list--item-right-padding-spacing-" + listItemPaddingRight
        : '', listItemPaddingLeft
        ? "rck-list--item-left-padding-spacing-" + listItemPaddingLeft
        : '', listItemMarginTop
        ? "rck-list--item-top-margin-spacing-" + listItemMarginTop
        : '', listItemMarginBottom
        ? "rck-list--item-bottom-margin-spacing-" + listItemMarginBottom
        : '', "rck-list--columns-" + columns, horizontalOrientation ? 'rck-list--horizontal' : '', allowWrapping ? 'rck-list--wrapped' : '', useNativeColumns ? '' : 'rck-list--no-native-columns', className || '');
};
var listClassNames$1 = memoize(listClassNames);

var ListTest;
(function (ListTest) {
    ListTest["prefix"] = "List";
})(ListTest || (ListTest = {}));
var List = function (_a) {
    var _b = _a.showSeparator, showSeparator = _b === void 0 ? true : _b, _c = _a.listItemPaddingTop, listItemPaddingTop = _c === void 0 ? 'small' : _c, listItemPaddingBottom = _a.listItemPaddingBottom, listItemPaddingRight = _a.listItemPaddingRight, listItemPaddingLeft = _a.listItemPaddingLeft, listItemMarginTop = _a.listItemMarginTop, listItemMarginBottom = _a.listItemMarginBottom, allowCustomListItemStyle = _a.allowCustomListItemStyle, _d = _a.columns, columns = _d === void 0 ? '1' : _d, horizontalOrientation = _a.horizontalOrientation, allowWrapping = _a.allowWrapping, _e = _a.useNativeColumns, useNativeColumns = _e === void 0 ? true : _e, _f = _a.className, className = _f === void 0 ? '' : _f, testId = _a.testId, _g = _a.disabled, disabled = _g === void 0 ? false : _g, children = _a.children;
    return (createElement("ul", { className: listClassNames$1(showSeparator, listItemPaddingTop, listItemPaddingBottom, listItemPaddingRight, listItemPaddingLeft, listItemMarginTop, listItemMarginBottom, columns, horizontalOrientation, allowWrapping, useNativeColumns, className), "data-testid": getTestId(ListTest.prefix, testId) }, Children.map(children, function (child) {
        var listItem = child;
        if (listItem === null) {
            return null;
        }
        if ((allowCustomListItemStyle &&
            listItem.type !== allowCustomListItemStyle) ||
            (!allowCustomListItemStyle &&
                listItem.type !== CompactStyleListItem &&
                listItem.type !== ActivityStyleListItem &&
                listItem.type !== FreeStyleListItem &&
                listItem.type !== RegularStyleListItem &&
                listItem.type !== LocationStyleListItem &&
                listItem.type !== CustomStyleListItem)) {
            throw new Error("List children have an invalid type: " + listItem.type);
        }
        return cloneElement(listItem, {
            disabled: disabled,
            parentTestId: testId,
        });
    })));
};
List.displayName = 'List';

var ListLinkTest;
(function (ListLinkTest) {
    ListLinkTest["prefix"] = "ListLink";
})(ListLinkTest || (ListLinkTest = {}));
var ListLink = function (_a) {
    var _b = _a.url, url = _b === void 0 ? '' : _b, useAsLink = _a.useAsLink, _c = _a.fontSize, fontSize = _c === void 0 ? 'small' : _c, _d = _a.color, color = _d === void 0 ? 'regular' : _d, isBold = _a.isBold, _e = _a.className, className = _e === void 0 ? '' : _e, testId = _a.testId, parentTestId = _a.parentTestId, onClick = _a.onClick, children = _a.children;
    return (React__default.createElement(Link$1, { useAsLink: useAsLink, href: url, className: classNames('rck-list-link', "rck-list-link--fsize-" + fontSize, "rck-list-link--" + color, className), onClick: onClick, testId: getTestId(ListLinkTest.prefix, getTestIdWithParentTestId(parentTestId, testId)) }, isBold ? React__default.createElement("strong", null, children) : children));
};
ListLink.displayName = 'ListLink';
var ListLink$1 = React__default.memo(ListLink);

var ListThumbnailTest;
(function (ListThumbnailTest) {
    ListThumbnailTest["prefix"] = "ListThumbnail";
})(ListThumbnailTest || (ListThumbnailTest = {}));
var ListThumbnail = function (_a) {
    var thumbnailUrl = _a.thumbnailUrl, altTextThumnail = _a.altTextThumnail, imageMinHeight = _a.imageMinHeight, imageMinWidth = _a.imageMinWidth, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId, parentTestId = _a.parentTestId;
    return (React__default.createElement("div", { className: classNames('rck-list-thumbnail', className), "data-testid": getTestId(ListThumbnailTest.prefix, getTestIdWithParentTestId(parentTestId, testId)) },
        React__default.createElement("div", { className: "rck-list-thumbnail__wrapper" },
            React__default.createElement("div", { className: "rck-list-thumbnail__wrapper__opacity-layer" }),
            React__default.createElement("img", { className: classNames('rck-list-thumbnail__wrapper__thumb', imageMinWidth
                    ? "rck-list-thumbnail__wrapper__thumb--min-width-" + imageMinWidth
                    : '', imageMinHeight
                    ? "rck-list-thumbnail__wrapper__thumb--min-height-" + imageMinHeight
                    : ''), src: thumbnailUrl, role: "presentation", alt: altTextThumnail }),
            React__default.createElement(Icon$1, { type: IconType.playCircle, className: "rck-list-thumbnail__wrapper__icon", family: IconFamily.regular, color: IconColor.contrast }))));
};
ListThumbnail.displayName = 'ListThumbnail';
var ListThumbnail$1 = React__default.memo(ListThumbnail);

var ClickableListItemTest;
(function (ClickableListItemTest) {
    ClickableListItemTest["prefix"] = "ClickableListItemTest";
})(ClickableListItemTest || (ClickableListItemTest = {}));
var ClickableListItem = function (_a) {
    var onClick = _a.onClick, role = _a.role, testId = _a.testId, useAsLink = _a.useAsLink, href = _a.href, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
    return !href && onClick ? (React__default.createElement(TransparentButton$1, { onClick: onClick, className: classNames('rck-list-item--clickable', className), testId: getTestId(ClickableListItemTest.prefix, testId) }, children)) : (React__default.createElement(Link$1, { className: classNames('rck-list-item--clickable', className), useAsLink: useAsLink, role: role, href: href, onClick: onClick, testId: getTestId(ClickableListItemTest.prefix, testId) }, children));
};
ClickableListItem.displayName = 'ClickableListItem';

var makeClickableListItem = function (Component) { return function (_a) {
    var onClick = _a.onClick, useAsLink = _a.useAsLink, href = _a.href, role = _a.role, _b = _a.clickableClassName, clickableClassName = _b === void 0 ? '' : _b, props = __rest(_a, ["onClick", "useAsLink", "href", "role", "clickableClassName"]);
    return onClick || href || useAsLink ? (React__default.createElement(Link$1, { className: classNames('rck-list-item--clickable', clickableClassName), useAsLink: useAsLink, role: role, href: href, onClick: onClick, "data-testid": getTestId('clickable', props.testId) },
        React__default.createElement(Component, __assign({}, props)))) : (React__default.createElement(Component, __assign({}, props)));
}; };

// eslint-disable-next-line import/prefer-default-export
var getWordBreakClass = function (prefix, type) { return (type ? prefix + "--word-break-" + type : ''); };

var ListColoredTextTest;
(function (ListColoredTextTest) {
    ListColoredTextTest["prefix"] = "ListColoredText";
})(ListColoredTextTest || (ListColoredTextTest = {}));
var ListColoredText = function (_a) {
    var color = _a.color, wordBreak = _a.wordBreak, testId = _a.testId, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children;
    return (React__default.createElement("span", { className: classNames('rck-list-colored-text', "rck-list-colored-text--" + color, getWordBreakClass('rck-list-colored-text', wordBreak), className), "data-testid": getTestId(ListColoredTextTest.prefix, testId) }, children));
};
ListColoredText.displayName = 'ListColoredText';
var ListColoredText$1 = React__default.memo(ListColoredText);

var ListCompactRightTitleTest;
(function (ListCompactRightTitleTest) {
    ListCompactRightTitleTest["prefix"] = "ListCompactRightTitle";
})(ListCompactRightTitleTest || (ListCompactRightTitleTest = {}));
var ListCompactRightTitle = function (_a) {
    var testId = _a.testId, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children;
    return (React__default.createElement("p", { className: classNames('rck-list-compact-right-title', className), "data-testid": testId }, children));
};
ListCompactRightTitle.displayName = 'ListCompactRightTitle';
var ListCompactRightTitle$1 = React__default.memo(ListCompactRightTitle);

var ListBckImageIconTest;
(function (ListBckImageIconTest) {
    ListBckImageIconTest["prefix"] = "ListItemBrandIcon";
})(ListBckImageIconTest || (ListBckImageIconTest = {}));
var ListBckImageIcon = function (_a) {
    var url = _a.url, testId = _a.testId, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React__default.createElement("div", { "data-testid": getTestId(ListBckImageIconTest.prefix, testId), className: classNames('rck-list-item-bck-image-icon', className), style: { backgroundImage: "url(" + url + ")" } }));
};
ListBckImageIcon.displayName = 'ListBckImageIcon';
var ListBckImageIcon$1 = React__default.memo(ListBckImageIcon);

var ListSecondaryTextTest;
(function (ListSecondaryTextTest) {
    ListSecondaryTextTest["prefix"] = "ListSecondaryText";
})(ListSecondaryTextTest || (ListSecondaryTextTest = {}));
var ListSecondaryText = function (_a) {
    var _b = _a.align, align = _b === void 0 ? TextAlign.left : _b, _c = _a.fontSize, fontSize = _c === void 0 ? 's' : _c, allowLines = _a.allowLines, _d = _a.renderAs, Tag = _d === void 0 ? 'p' : _d, children = _a.children, _e = _a.className, className = _e === void 0 ? '' : _e, testId = _a.testId, parentTestId = _a.parentTestId;
    return (React__default.createElement(Tag, { className: classNames("rck-list-secondary-text", "rck-list-secondary-text--align-" + align, "rck-list-secondary-text--fsize-" + fontSize, allowLines ? "rck-list-secondary-text--ellipsis-for-" + allowLines : '', className), "data-testid": getTestId(ListSecondaryTextTest.prefix, getTestIdWithParentTestId(parentTestId, testId)) }, children));
};
ListSecondaryText.displayName = 'ListSecondaryText';
var ListSecondaryText$1 = React__default.memo(ListSecondaryText);

var CloudListTest;
(function (CloudListTest) {
    CloudListTest["prefix"] = "CloudList";
})(CloudListTest || (CloudListTest = {}));
var CloudList = function (_a) {
    var allowedListItemType = _a.allowedListItemType, _b = _a.listItemMaxWidth, listItemMaxWidth = _b === void 0 ? '100%' : _b, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId;
    return (createElement("ul", { className: classNames('rck-cloud-list', "rck-cloud-list--maxwidth-" + listItemMaxWidth.replace('%', 'pc'), className), "data-testid": getTestId(CloudListTest.prefix, testId) }, Children.map(children, function (child) {
        var listItem = child;
        if (listItem === null) {
            return null;
        }
        if (listItem.type !== allowedListItemType) {
            throw new Error("CloudList children have an invalid type: " + listItem.type);
        }
        return createElement("li", null, child);
    })));
};
CloudList.displayName = 'CloudList';

var useDomAnimation = function (el, animationClass, milliseconds, trigger, disabled) {
    if (milliseconds === void 0) { milliseconds = 200; }
    if (trigger === void 0) { trigger = undefined; }
    if (disabled === void 0) { disabled = false; }
    useEffect(function () {
        if (el && el.current) {
            if (!disabled && !el.current.classList.contains(animationClass)) {
                el.current.classList.add(animationClass);
                setTimeout(function () {
                    if (el && el.current) {
                        el.current.classList.remove(animationClass);
                    }
                }, milliseconds);
            }
        }
    }, trigger);
};

var TabPanelTest;
(function (TabPanelTest) {
    TabPanelTest["prefix"] = "TabPanel";
})(TabPanelTest || (TabPanelTest = {}));
var TabPanel = function (_a) {
    var name = _a.name, _b = _a.className, className = _b === void 0 ? '' : _b, animateWhenChange = _a.animateWhenChange, testId = _a.testId, children = _a.children;
    var tabPanelRef = useRef(document.createElement('div'));
    useDomAnimation(tabPanelRef, 'rck-tab-panel--entering', 200, [animateWhenChange], !animateWhenChange);
    return (createElement("div", { id: name, className: classNames("rck-tab-panel", className), role: "tabpanel", "data-testid": getTestId(TabPanelTest.prefix, testId, name), ref: tabPanelRef }, children));
};
TabPanel.displayName = 'TabPanel';

var TabsTest;
(function (TabsTest) {
    TabsTest["prefix"] = "Tabs";
    TabsTest["tab"] = "Tab";
})(TabsTest || (TabsTest = {}));
var Tabs = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, onChange = _a.onChange, animateOnChange = _a.animateOnChange, testId = _a.testId, children = _a.children;
    var handleClick = function (name, disabled) { return function () {
        if (onChange && !disabled) {
            onChange(name);
        }
    }; };
    var panel = null;
    var name;
    return (createElement("div", { className: classNames("rck-tabs", className), "data-testid": getTestId(TabsTest.prefix, testId) },
        createElement("ul", { className: "rck-tabs__list" }, Children.map(children, function (child) {
            var tabPanel = child;
            if (tabPanel === null) {
                return null;
            }
            if (tabPanel.type !== TabPanel) {
                throw Error('Tabs must containn TabPanel children');
            }
            var isActive = !tabPanel.props.disabled && tabPanel.props.active;
            if (isActive) {
                name = tabPanel.props.name;
                panel = tabPanel;
            }
            return (createElement("li", { className: classNames("rck-tab", isActive ? "rck-tab--active" : '', tabPanel.props.disabled ? 'rck-tab--disabled' : '', className), "data-name": tabPanel.props.name, role: "tab", key: tabPanel.props.name, onClick: handleClick(tabPanel.props.name, tabPanel.props.disabled), onKeyDown: handleClick(tabPanel.props.name, tabPanel.props.disabled), tabIndex: 0, "data-testid": getTestId(TabsTest.tab, testId, tabPanel.props.name) }, isActive ? (createElement("strong", null, tabPanel.props.content)) : (tabPanel.props.content)));
        })),
        panel &&
            cloneElement(panel, {
                animateWhenChange: animateOnChange ? name : undefined,
            })));
};
Tabs.displayName = 'Tabs';

var InstructionBlockTest;
(function (InstructionBlockTest) {
    InstructionBlockTest["prefix"] = "InstructionBlock";
})(InstructionBlockTest || (InstructionBlockTest = {}));
var InstructionBlock = function (_a) {
    var block = _a.block, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId, children = _a.children;
    return (React__default.createElement("div", { "data-testid": getTestId(InstructionBlockTest.prefix, testId), className: classNames('rck-instruction-block', block ? 'rck-instruction-block--block' : '', className) }, children));
};
InstructionBlock.displayName = 'InstructionBlock';
var InstructionBlock$1 = React__default.memo(InstructionBlock);

var ContentSeparatorTest;
(function (ContentSeparatorTest) {
    ContentSeparatorTest["prefix"] = "ContentSeparator";
})(ContentSeparatorTest || (ContentSeparatorTest = {}));
var ContentSeparator = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId;
    return (createElement("div", { className: classNames('rck-content-separator', className), "data-testid": getTestId(ContentSeparatorTest.prefix, testId) }));
};
ContentSeparator.displayName = 'ContentSeparator';
var ContentSeparator$1 = memo(ContentSeparator);

var InstructionCardTest;
(function (InstructionCardTest) {
    InstructionCardTest["prefix"] = "InstructionCard";
})(InstructionCardTest || (InstructionCardTest = {}));
var InstructionCard = function (_a) {
    var iconType = _a.iconType, iconColor = _a.iconColor, title = _a.title, description = _a.description, instructions = _a.instructions, url = _a.url, _b = _a.compact, compact = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId;
    return (React__default.createElement(FlexLayout, { mainaxis: "column", crossaxisAlignment: "center", "data-testid": getTestId(InstructionCardTest.prefix, testId), className: classNames('rck-instruction-card', compact ? 'rck-instruction-card--compact' : '', className) },
        React__default.createElement(Icon$1, { type: iconType, color: iconColor, size: compact ? IconSize.x2 : IconSize.x3, className: "rck-instruction-card__icon" }),
        React__default.createElement("p", { className: "rck-instruction-card__title" }, title),
        !compact && (React__default.createElement("p", { className: "rck-instruction-card__description" }, description)),
        url && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(FlexLayout, { mainaxis: "row", mainaxisAlignment: "space-between", crossaxisAlignment: "center", alignSelf: "stretch", paddingBottom: "8" },
                React__default.createElement(Link$1, { href: url, className: "rck-instruction-card__link" }, instructions),
                React__default.createElement(Icon$1, { type: IconType.angleRight, color: IconColor.regular, size: IconSize.x2 })),
            React__default.createElement(ContentSeparator$1, null)))));
};
InstructionCard.displayName = 'InstructionCard';

var StyledInstructionTest;
(function (StyledInstructionTest) {
    StyledInstructionTest["prefix"] = "StyledInstruction";
})(StyledInstructionTest || (StyledInstructionTest = {}));
var StyledInstruction = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId, children = _a.children, color = _a.color;
    return (React__default.createElement("div", { "data-testid": getTestId(StyledInstructionTest.prefix, testId), className: classNames('rck-styled-instruction', color ? "rck-styled-instruction--color-" + color : '', className) }, children));
};
StyledInstruction.displayName = 'StyledInstruction';
var StyledInstruction$1 = React__default.memo(StyledInstruction);

var SelectionBarTest;
(function (SelectionBarTest) {
    SelectionBarTest["prefix"] = "SelectionBar";
})(SelectionBarTest || (SelectionBarTest = {}));
var SelectionBar = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, title = _a.title, testId = _a.testId, hasNext = _a.hasNext, hasPrev = _a.hasPrev, onClickNext = _a.onClickNext, onClickPrev = _a.onClickPrev;
    return (createElement("div", { className: classNames(className, 'rck-selectionbar'), "data-testid": getTestId(SelectionBarTest.prefix, testId) },
        createElement("div", { className: "rck-selectionbar__content" },
            createElement(TransparentButton$1, { onClick: onClickPrev, className: classNames('rck-selectionbar__content__button', !hasPrev ? 'rck-selectionbar__content__button--hidden' : '') },
                createElement(Icon$1, { type: IconType.angleLeft, color: IconColor.regular, size: IconSize.lg })),
            createElement(InstructionBlock$1, { className: "rck-selectionbar__content__title", block: false }, title),
            createElement(TransparentButton$1, { onClick: onClickNext, className: classNames('rck-selectionbar__content__button', !hasNext ? 'rck-selectionbar__content__button--hidden' : '') },
                createElement(Icon$1, { type: IconType.angleRight, color: IconColor.regular, size: IconSize.lg })))));
};
SelectionBar.displayName = 'SelectionBar';

var SpinnerTest;
(function (SpinnerTest) {
    SpinnerTest["prefix"] = "Spinner";
})(SpinnerTest || (SpinnerTest = {}));
var Spinner = function (_a) {
    var size = _a.size, color = _a.color, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId;
    return (createElement("div", { className: classNames('rck-spinner', "rck-spinner--size-" + size, "rck-spinner--color-" + color, className), "data-testid": getTestId(SpinnerTest.prefix, testId) },
        createElement("div", { className: "rck-spinner__bounce1" }),
        createElement("div", { className: "rck-spinner__bounce2" }),
        createElement("div", { className: "rck-spinner__bounce3" })));
};
Spinner.displayName = 'Spinner';

/* eslint-disable react/jsx-wrap-multilines */
var GroupHeaderTest;
(function (GroupHeaderTest) {
    GroupHeaderTest["prefix"] = "GroupHeader";
})(GroupHeaderTest || (GroupHeaderTest = {}));
var GroupHeader = function (_a) {
    var onClickHelp = _a.onClickHelp, helpUrl = _a.helpUrl, useAsLink = _a.useAsLink, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId;
    return (React__default.createElement("div", { className: classNames('rck-group-header', className), "data-testid": getTestId(GroupHeaderTest.prefix, testId) },
        React__default.createElement(Header, { type: "h3" }, children),
        (onClickHelp || helpUrl) && (React__default.createElement("div", { className: "rck-group-header__action-element" },
            !helpUrl && (React__default.createElement(TransparentButton$1, { onClick: onClickHelp },
                React__default.createElement(Icon$1, { type: IconType.questionCircle, color: IconColor.regular }))),
            helpUrl && (React__default.createElement(Link$1, { href: helpUrl, useAsLink: useAsLink },
                React__default.createElement(Icon$1, { type: IconType.questionCircle, color: IconColor.regular })))))));
};
GroupHeader.displayName = 'GroupHeader';
var GroupHeader$1 = React__default.memo(GroupHeader);

var LabelTest;
(function (LabelTest) {
    LabelTest["prefix"] = "Label";
})(LabelTest || (LabelTest = {}));
var Label = function (_a) {
    var htmlFor = _a.htmlFor, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, testId = _a.testId, ellipsis = _a.ellipsis;
    return (React__default.createElement("label", { htmlFor: htmlFor, className: classNames('rck-label', ellipsis ? 'rck-label--ellipsis' : '', className), "data-testid": getTestId(LabelTest.prefix, testId) }, children));
};
Label.displayName = 'Label';
var Label$1 = React__default.memo(Label);

var EmptyPlaceholderTest;
(function (EmptyPlaceholderTest) {
    EmptyPlaceholderTest["prefix"] = "EmptyPlaceholder";
})(EmptyPlaceholderTest || (EmptyPlaceholderTest = {}));
var EmptyPlaceholder = function (_a) {
    var text = _a.text, icon = _a.icon, coloredBackground = _a.coloredBackground, fillAvailableSpace = _a.fillAvailableSpace, _b = _a.maxWidth, maxWidth = _b === void 0 ? '100%' : _b, centered = _a.centered, smallText = _a.smallText, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId;
    return (React__default.createElement("div", { className: classNames('rck-empty-placeholder', fillAvailableSpace ? 'rck-empty-placeholder--fill' : '', centered ? 'rck-empty-placeholder--center' : '', coloredBackground ? 'rck-empty-placeholder--colored-background' : '', smallText ? 'rck-empty-placeholder--small-text' : '', className), "data-testid": getTestId(EmptyPlaceholderTest.prefix, testId) },
        React__default.createElement(FlexLayout, { mainaxis: "column", maxWidth: maxWidth },
            icon && React__default.createElement("div", { className: "rck-empty-placeholder__icon" }, icon),
            text)));
};
EmptyPlaceholder.displayName = 'EmptyPlaceholder';
var EmptyPlaceholder$1 = React__default.memo(EmptyPlaceholder);

var DeactivableContentTest;
(function (DeactivableContentTest) {
    DeactivableContentTest["prefix"] = "DeactivableListItem";
})(DeactivableContentTest || (DeactivableContentTest = {}));
var DeactivableContent = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, testId = _a.testId, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c;
    var listItemRef = useRef(document.createElement('div'));
    useElementDisable(listItemRef, disabled, 'rck-deactivable-content--disabled', 'rck-deactivable-content__overlap');
    return (React__default.createElement("div", { "data-testid": getTestId(DeactivableContentTest.prefix, testId), ref: listItemRef, className: classNames('rck-deactivable-content', className), "aria-disabled": disabled }, children));
};
DeactivableContent.displayName = 'DeactivableContent';

var SliderTest;
(function (SliderTest) {
    SliderTest["prefix"] = "Slider";
})(SliderTest || (SliderTest = {}));
var Slider = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, name = _a.name, id = _a.id, disabled = _a.disabled, block = _a.block, minValue = _a.minValue, maxValue = _a.maxValue, value = _a.value, testId = _a.testId, formatLabel = _a.formatLabel, onInput = _a.onInput, onChange = _a.onChange;
    var inputRef = useRef(document.createElement('input'));
    var handleOnInput = function (ev) {
        if (!disabled) {
            if (onInput) {
                onInput(ev, inputRef.current.value);
            }
        }
    };
    var handleOnChange = function (ev) {
        if (!disabled) {
            if (onChange) {
                onChange(ev, inputRef.current.value);
            }
        }
    };
    return (createElement("div", { className: classNames(className, 'rck-slider', block ? 'rck-slider--block' : '', disabled ? 'rck-slider--disabled' : '') },
        createElement("label", { htmlFor: id, "data-testid": getTestId(SliderTest.prefix, testId) },
            value,
            " ",
            formatLabel),
        createElement("input", { id: id, className: "rck-slider", name: name, ref: inputRef, type: "range", min: minValue, max: maxValue, value: value, onInput: handleOnInput, onChange: handleOnChange })));
};
Slider.displayName = 'Slider';

var DomainTrustSealTest;
(function (DomainTrustSealTest) {
    DomainTrustSealTest["prefix"] = "DomainTrustSeal";
})(DomainTrustSealTest || (DomainTrustSealTest = {}));
var getConfigByReputation = function (mode, level) {
    switch (level) {
        case 'excellent':
            return {
                icon: mode === 'trustworthiness' ? (React__default.createElement(Icon$1, { type: IconType.grin, color: IconColor.success, size: IconSize.x2 })) : (React__default.createElement(Icon$1, { type: IconType.thumbsUp, color: IconColor.success, size: IconSize.x2 })),
                className: 'good',
            };
        case 'good':
            return {
                icon: mode === 'trustworthiness' ? (React__default.createElement(Icon$1, { type: IconType.smile, color: IconColor.success, size: IconSize.x2 })) : (React__default.createElement(Icon$1, { type: IconType.thumbsUp, color: IconColor.success, size: IconSize.x2 })),
                className: 'good',
            };
        case 'unsatisfactory':
            return {
                icon: mode === 'trustworthiness' ? (React__default.createElement(Icon$1, { type: IconType.meh, color: IconColor.warning, size: IconSize.x2 })) : (React__default.createElement(Icon$1, { type: IconType.thumbsDown, color: IconColor.warning, size: IconSize.x2 })),
                className: 'unsatisfactory',
            };
        case 'poor':
            return {
                icon: mode === 'trustworthiness' ? (React__default.createElement(Icon$1, { type: IconType.frown, color: IconColor.error, size: IconSize.x2 })) : (React__default.createElement(Icon$1, { type: IconType.thumbsDown, color: IconColor.error, size: IconSize.x2 })),
                className: 'poor',
            };
        case 'very-poor':
            return {
                icon: mode === 'trustworthiness' ? (React__default.createElement(Icon$1, { type: IconType.sadTear, color: IconColor.error, size: IconSize.x2 })) : (React__default.createElement(Icon$1, { type: IconType.thumbsDown, color: IconColor.error, size: IconSize.x2 })),
                className: 'poor',
            };
        default:
            return {
                icon: mode === 'trustworthiness' ? (React__default.createElement(Icon$1, { type: IconType.questionCircle, color: IconColor.neutral, size: IconSize.x2 })) : (React__default.createElement(Icon$1, { type: IconType.questionCircle, color: IconColor.neutral, size: IconSize.x2 })),
                className: 'neutral',
            };
    }
};
var DomainTrustSeal = function (_a) {
    var mode = _a.mode, _b = _a.level, level = _b === void 0 ? 'unknown' : _b, title = _a.title, levelDescription = _a.description, testId = _a.testId, _c = _a.className, className = _c === void 0 ? '' : _c;
    var configuration = getConfigByReputation(mode, level);
    return (React__default.createElement("div", { "data-testid": getTestId(DomainTrustSealTest.prefix, testId), className: classNames('rck-domain-trust', "rck-domain-trust--" + configuration.className, className) },
        React__default.createElement("div", null, configuration.icon),
        React__default.createElement("div", { className: "rck-domain-trust__info" },
            React__default.createElement("p", { className: "rck-domain-trust__info__title" }, title),
            React__default.createElement("p", { className: "rck-domain-trust__info__description" }, levelDescription))));
};
DomainTrustSeal.displayName = 'DomainTrustSeal';
var DomainTrustSeal$1 = React__default.memo(DomainTrustSeal);

var SvgTest;
(function (SvgTest) {
    SvgTest["prefix"] = "Svg";
})(SvgTest || (SvgTest = {}));
var Svg = function (_a) {
    var height = _a.height, width = _a.width, color = _a.color, testId = _a.testId, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React__default.createElement("span", { className: classNames('rck-svg', height ? "rck-svg--size-height-" + height : '', width ? "rck-svg--size-width-" + width : '', color ? "rck-svg--color-" + color : '', className), "data-testid": getTestId(SvgTest.prefix, testId) }, children));
};
Svg.displayName = 'Svgs';
var Svg$1 = React__default.memo(Svg);

var AffiliateBadgeTest;
(function (AffiliateBadgeTest) {
    AffiliateBadgeTest["prefix"] = "AffiliateBadge";
})(AffiliateBadgeTest || (AffiliateBadgeTest = {}));
var AffiliateBadge = function (_a) {
    var iconSrc = _a.iconSrc, description = _a.description, testId = _a.testId, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (createElement("div", { className: classNames('rck-affiliate-badge', className), "data-testid": getTestId(AffiliateBadgeTest.prefix, testId) },
        createElement("img", { src: iconSrc, alt: description })));
};
AffiliateBadge.displayName = 'AffiliateBadge';
var AffiliateBadge$1 = memo(AffiliateBadge);

var PageTitleTest;
(function (PageTitleTest) {
    PageTitleTest["prefix"] = "PageTitle";
})(PageTitleTest || (PageTitleTest = {}));
var PageTitle = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, profileInfoHeader = _a.profileInfoHeader, _b = _a.size, size = _b === void 0 ? 'regular' : _b, actions = _a.actions, centered = _a.centered, _c = _a.className, className = _c === void 0 ? '' : _c, testId = _a.testId;
    var backAction = actions === null || actions === void 0 ? void 0 : actions.find(function (action) { return action.actionName === 'back'; });
    var menuAction = actions === null || actions === void 0 ? void 0 : actions.find(function (action) { return action.actionName === 'menu'; });
    var otherActions = actions === null || actions === void 0 ? void 0 : actions.filter(function (action) {
        return action.actionName !== 'back' &&
            action.actionName !== 'menu' &&
            action.actionName !== '';
    });
    var renderIcon = function (action) {
        var _a;
        var iconColor = (_a = action.iconColor) !== null && _a !== void 0 ? _a : IconColor.black;
        var iconSize = IconSize.lg;
        if (action.icon)
            return action.icon;
        switch (action.actionName) {
            case 'menu':
                return React__default.createElement(Icon$1, { type: IconType.bars, color: iconColor, size: iconSize });
            case 'back':
                return (React__default.createElement(Icon$1, { type: IconType.arrowLeft, color: iconColor, size: iconSize }));
            case 'edit':
                return React__default.createElement(Icon$1, { type: IconType.edit, color: iconColor, size: iconSize });
            case 'delete':
                return (React__default.createElement(Icon$1, { type: IconType.trashAlt, color: iconColor, size: iconSize }));
            case 'search':
                return (React__default.createElement(Icon$1, { type: IconType.search, color: iconColor, size: iconSize }));
            case 'settings':
                return React__default.createElement(Icon$1, { type: IconType.cog, color: iconColor, size: iconSize });
            default:
                return action.icon
                    ? React__default.cloneElement(action.icon, { color: iconColor })
                    : null;
        }
    };
    var renderAction = function (action, isRightSide) { return (React__default.createElement("div", { key: action.actionName, className: classNames('rck-page-title__action', isRightSide ? 'rck-page-title__action--right' : '') },
        action.location && (React__default.createElement(Link$1, { href: action.location, onClick: function () {
                if (action.onClick)
                    action.onClick();
            } }, renderIcon(action))),
        !action.location && (React__default.createElement(TransparentButton$1, { fillAvailableSpace: true, testId: getTestId(PageTitleTest.prefix, testId, action.actionName), onClick: function () {
                if (action.onClick)
                    action.onClick();
            } }, renderIcon(action))))); };
    return (React__default.createElement("div", { className: classNames('rck-page-title', "rck-page-title--" + size, className), "data-testid": getTestId(PageTitleTest.prefix, testId) },
        React__default.createElement("div", { className: "rck-page-title--left" },
            backAction && renderAction(backAction),
            menuAction && renderAction(menuAction),
            profileInfoHeader && (React__default.createElement("div", { className: "rck-page-title__header-info" }, profileInfoHeader)),
            React__default.createElement("div", { className: "rck-page-title__title-wrapper" },
                title && (React__default.createElement("div", { className: classNames("rck-page-title__title", backAction ? 'rck-page-title__title--level-2' : '', centered ? 'rck-page-title__title--centered' : '') }, title)),
                subtitle && size === 'regular' && (React__default.createElement("div", { className: classNames('rck-page-title__subtitle', centered ? 'rck-page-title__subtitle--centered' : '') }, subtitle)))),
        otherActions && (otherActions === null || otherActions === void 0 ? void 0 : otherActions.length) !== 0 && (React__default.createElement("div", { className: "rck-page-title--right" }, otherActions === null || otherActions === void 0 ? void 0 : otherActions.filter(function (action) { return action.actionName !== ''; }).map(function (action) { return renderAction(action, true); })))));
};
PageTitle.displayName = 'PageTitle';

var ProfileInfoHeaderTest;
(function (ProfileInfoHeaderTest) {
    ProfileInfoHeaderTest["prefix"] = "ProfileInfoHeader";
})(ProfileInfoHeaderTest || (ProfileInfoHeaderTest = {}));
var ProfileInfoHeader = function (_a) {
    var name = _a.name, avatar = _a.avatar, status = _a.status, statusMessage = _a.statusMessage, _b = _a.size, size = _b === void 0 ? 'regular' : _b, onEdit = _a.onEdit, testId = _a.testId, _c = _a.className, className = _c === void 0 ? '' : _c;
    return (React__default.createElement("div", { className: classNames('rck-profile-info-header', "rck-profile-info-header--" + size, className), "data-testid": getTestId(ProfileInfoHeaderTest.prefix, testId) },
        React__default.createElement("div", { className: "rck-profile-info-header__avatar" }, React__default.cloneElement(avatar, {
            size: size === 'small' ? AvatarSize.extraSmall : AvatarSize.medium,
            icon: onEdit ? (React__default.createElement(TransparentButton$1, { onClick: onEdit },
                React__default.createElement(Icon$1, { type: IconType.pencil, color: IconColor.greenDecorationContrast, family: IconFamily.solid, circle: true }))) : (undefined),
        })),
        React__default.createElement("div", { className: "rck-profile-info-header__content" },
            React__default.createElement("div", { className: "rck-profile-info-header__content__name" }, name),
            React__default.createElement("div", { className: classNames('rck-profile-info-header__content__status', "rck-profile-info-header__content__status--" + status) }, statusMessage))));
};
ProfileInfoHeader.displayName = 'ProfileInfoHeader';
var ProfileInfoHeader$1 = React__default.memo(ProfileInfoHeader);

var LicenseInfoContainerTest;
(function (LicenseInfoContainerTest) {
    LicenseInfoContainerTest["prefix"] = "LicenseInfoContainer";
})(LicenseInfoContainerTest || (LicenseInfoContainerTest = {}));
var LicenseInfoContainer = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, affiliateBadgeDescription = _a.affiliateBadgeDescription, _c = _a.affiliateBadgeIconSrc, affiliateBadgeIconSrc = _c === void 0 ? '' : _c, licenseTitle = _a.licenseTitle, licenseSubtitle = _a.licenseSubtitle, licenseBadgeText = _a.licenseBadgeText, licenseBadgeClick = _a.licenseBadgeClick, licenseLinkTo = _a.licenseLinkTo, useAsLink = _a.useAsLink, testId = _a.testId;
    return (React__default.createElement("div", { className: classNames('rck-license-info-container', className), "datatest-id": getTestId(LicenseInfoContainerTest.prefix, testId) },
        React__default.createElement("ul", { className: "rck-license-info-container__optionals" }, affiliateBadgeIconSrc ? (React__default.createElement("li", { className: "rck-license-info-container__affiliate-badge" },
            React__default.createElement(AffiliateBadge$1, { iconSrc: affiliateBadgeIconSrc, description: affiliateBadgeDescription }))) : (React__default.createElement(Link$1, { href: licenseLinkTo, useAsLink: useAsLink },
            licenseTitle && (React__default.createElement("li", { className: "rck-license-info-container__license-title" },
                React__default.createElement("span", null, licenseTitle))),
            licenseSubtitle && (React__default.createElement("li", { className: "rck-license-info-container__license-subtitle" },
                React__default.createElement("span", null, licenseSubtitle))),
            licenseBadgeText && licenseBadgeClick && (React__default.createElement("li", null,
                React__default.createElement(FlexLayout, { mainaxis: "row", mainaxisAlignment: "center" },
                    React__default.createElement(Button$1, { onClick: licenseBadgeClick, size: ButtonSize.extraSmall, block: true }, licenseBadgeText)))))))));
};
LicenseInfoContainer.displayName = 'LicenseInfoContainer';

var BannerTest;
(function (BannerTest) {
    BannerTest["prefix"] = "Banner";
    BannerTest["actionElement"] = "Action__close";
})(BannerTest || (BannerTest = {}));
var Banner = function (_a) {
    var type = _a.type, icon = _a.icon, showCloseIcon = _a.showCloseIcon, centered = _a.centered, fullWidth = _a.fullWidth, _b = _a.rounded, rounded = _b === void 0 ? true : _b, testId = _a.testId, _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children, onClose = _a.onClose;
    return (React__default.createElement("div", { className: classNames('rck-banner', "rck-banner--" + type, fullWidth ? 'rck-banner--full-width' : '', !rounded ? 'rck-banner--no-rounded' : '', className), "data-testid": getTestId(BannerTest.prefix, testId) },
        icon && React__default.createElement("div", { className: "rck-banner__icon" }, icon),
        React__default.createElement("div", { className: classNames('rck-banner__text', centered ? "rck-banner__text--centered" : '') }, children),
        showCloseIcon && (React__default.createElement("div", { className: "rck-banner__icon-right", onClick: onClose, role: "button", onKeyDown: onClose, tabIndex: 0, "data-testid": getTestId(BannerTest.prefix, testId, BannerTest.actionElement) },
            React__default.createElement(Icon$1, { type: IconType.times, size: IconSize.lg })))));
};
Banner.displayName = 'Banner';
var Banner$1 = React__default.memo(Banner);

var SafeArea = function () { return createElement("div", { className: "rck-safe-area" }); };
SafeArea.displayName = 'SafeArea';

var NotificationTest;
(function (NotificationTest) {
    NotificationTest["prefix"] = "Notification";
})(NotificationTest || (NotificationTest = {}));
var getNotificagtionIcon = function (type) {
    switch (type) {
        case 'warning':
            return (React__default.createElement(Icon$1, { type: IconType.exclamation, color: IconColor.black, size: IconSize.x2, family: IconFamily.solid }));
        case 'error':
            return (React__default.createElement(Icon$1, { type: IconType.times, color: IconColor.black, size: IconSize.x2 }));
        case 'success':
            return (React__default.createElement(Icon$1, { type: IconType.check, color: IconColor.black, size: IconSize.x2 }));
        default:
            return undefined;
    }
};
var Notification = function (_a) {
    var message = _a.message, title = _a.title, _b = _a.type, type = _b === void 0 ? 'info' : _b, position = _a.position, icon = _a.icon, _c = _a.onClose, onClose = _c === void 0 ? function () { } : _c, testId = _a.testId, _d = _a.className, className = _d === void 0 ? '' : _d;
    var notificationIcon = icon !== null && icon !== void 0 ? icon : getNotificagtionIcon(type);
    return (React__default.createElement("div", { className: classNames('rck-notification', "rck-notification--position-" + position, "rck-notification--type-" + type, className), "data-testid": getTestId(NotificationTest.prefix, testId) },
        React__default.createElement("div", { className: "rck-notification__wrapper" },
            notificationIcon && (React__default.createElement("div", { className: "rck-notification__icon" }, notificationIcon)),
            React__default.createElement("div", { className: "rck-notification__content" },
                title && (React__default.createElement("h4", { className: "rck-notification__content__title" }, title)),
                React__default.createElement("div", { className: "rck-notification__content__message" }, message)),
            React__default.createElement("div", { className: "rck-notification__close" },
                React__default.createElement(TransparentButton$1, { onClick: onClose },
                    React__default.createElement(Icon$1, { type: IconType.times, color: IconColor.secondary, size: IconSize.lg }))))));
};
Notification.displayName = 'Notification';

var NotificationManager = /** @class */ (function () {
    function NotificationManager() {
        var _this = this;
        this.onCloseNotificationHandler = function () {
            _this.removeScheduledTaskToRemoveNotification();
            _this.removeCurrentNotification();
        };
        this.defaultPosition = 'bottom-center';
        this.defaultHook = 'portal-notifications';
        this.defaultTimeout = 4000;
        this.createPortal();
    }
    NotificationManager.prototype.createPortal = function () {
        if (isTestEnv())
            return;
        if (document.getElementById(this.defaultHook) === null) {
            var portal = document.createElement('div');
            portal.setAttribute('id', this.defaultHook);
            document.body.appendChild(portal);
        }
    };
    NotificationManager.prototype.removeCurrentNotification = function () {
        if (isTestEnv())
            return;
        var currNotif = document.getElementById(this.defaultHook);
        if (currNotif && currNotif.firstChild) {
            ReactDOM__default.unmountComponentAtNode(currNotif);
        }
    };
    NotificationManager.prototype.scheduleTaskToRemoveNotification = function (ms) {
        var _this = this;
        this.timeout = setTimeout(function () {
            _this.removeCurrentNotification();
        }, ms !== null && ms !== void 0 ? ms : this.defaultTimeout);
    };
    NotificationManager.prototype.removeScheduledTaskToRemoveNotification = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = undefined;
        }
    };
    NotificationManager.getInstance = function () {
        if (!NotificationManager.instance) {
            NotificationManager.instance = new NotificationManager();
        }
        return NotificationManager.instance;
    };
    NotificationManager.prototype.setDefaultPosition = function (position) {
        this.defaultPosition = position;
    };
    NotificationManager.prototype.setDefaultHook = function (defaultHook) {
        var portal = document.getElementById(this.defaultHook);
        if (portal) {
            portal.remove();
        }
        this.defaultHook = defaultHook;
        this.createPortal();
    };
    NotificationManager.prototype.setDefaultTimeout = function (ms) {
        this.defaultTimeout = ms;
    };
    NotificationManager.prototype.sendWithoutTimeout = function (title, message, type, icon, onClose, position) {
        var _this = this;
        if (isTestEnv())
            return;
        ReactDOM__default.render(React__default.createElement(Notification, { message: message, type: type, title: title, position: position !== null && position !== void 0 ? position : this.defaultPosition, icon: icon, onClose: function (ev) {
                _this.onCloseNotificationHandler();
                if (onClose) {
                    onClose(ev);
                }
            } }), document.getElementById(this.defaultHook));
    };
    NotificationManager.prototype.send = function (title, message, type, icon, position, timeout, onClose) {
        this.removeScheduledTaskToRemoveNotification();
        this.removeCurrentNotification();
        this.sendWithoutTimeout(title, message, type, icon, onClose, position);
        this.scheduleTaskToRemoveNotification(timeout);
    };
    return NotificationManager;
}());

var FreeTextTest;
(function (FreeTextTest) {
    FreeTextTest["prefix"] = "FreeText";
})(FreeTextTest || (FreeTextTest = {}));
var FreeText = function (_a) {
    var fontSize = _a.fontSize, fontWeight = _a.fontWeight, color = _a.color, testId = _a.testId, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React__default.createElement("span", { className: classNames('rck-free-text', "rck-free-text--font-size-" + fontSize, "rck-free-text--color-" + color, "rck-free-text--font-weight-" + fontWeight, className), "data-testid": getTestId(FreeTextTest.prefix, testId) }, children));
};
FreeText.displayName = 'FreeText';

export { Accordion, AccordionItem, AccordionItemTest, AccordionMenu, AccordionMenuTest, AccordionTest, AccountInfoHeader$1 as AccountInfoHeader, AccountInfoHeaderTest, ActionInput$1 as ActionInput, ActionInputIconPosition, ActionInputTest, ActionableContent, ActivityStyleListItem, ActivityStyleListItemTest, AffiliateBadge$1 as AffiliateBadge, AffiliateBadgeTest, AlertBox$1 as AlertBox, AlertBoxTest, AlertBoxType, Avatar, AvatarSize, AvatarStatus, AvatarTest, Badge$1 as Badge, BadgeTest, BadgeType, Banner$1 as Banner, BannerTest, BrandsHeader, BrandsHeaderTest, Button$1 as Button, ButtonIconPosition, ButtonSize, ButtonTest, Card, CardTest, Checkbox, CheckboxTest, ClickableListItem, ClickableListItemTest, CloudList, CloudListTest, CompactStyleListItem, CompactStyleListItemTest, ContentSeparator$1 as ContentSeparator, ContentSeparatorTest, CopyBox, CopyBoxTest, CustomStyleListItem, CustomStyleListItemTest, DeactivableContent, DeactivableContentTest, DomainTrustSeal$1 as DomainTrustSeal, DomainTrustSealTest, Dropdown, DropdownActionElementTest, DropdownAlignment, DropdownElementOrientation, DropdownFooter, DropdownFooterTest, DropdownHeader, DropdownHeaderTest, FloatingMenuPlacement as DropdownMenuPlacement, DropdownOption, DropdownOptionTest, DropdownTest, EmptyPlaceholder$1 as EmptyPlaceholder, FlexLayout, FlexLayoutTest, FreeStyleListItem, FreeStyleListItemTest, FreeText, FreeTextTest, GlobalType, GroupHeader$1 as GroupHeader, GroupHeaderTest, Icon$1 as Icon, IconAdapter$1 as IconAdapter, IconColor, IconFamily, IconSize, IconTest, IconType, InputShowIconWhen, InstructionBlock$1 as InstructionBlock, InstructionBlockTest, InstructionCard, InstructionCardTest, Label$1 as Label, LabelTest, Layout, LayoutTest, LicenseInfoContainer, LicenseInfoContainerTest, Link$1 as Link, List, ListBckImageIcon$1 as ListBckImageIcon, ListBckImageIconTest, ListColoredText$1 as ListColoredText, ListColoredTextTest, ListCompactRightSubtitle$1 as ListCompactRightSubtitle, ListCompactRightSubtitleTest, ListCompactRightTitle$1 as ListCompactRightTitle, ListCompactRightTitleTest, ListCompactSubtitle$1 as ListCompactSubtitle, ListCompactSubtitleTest, ListCompactTitle$1 as ListCompactTitle, ListCompactTitleTest, ListItemTopPadding, ListItemVerticalAlign, ListLink$1 as ListLink, ListLinkTest, ListSecondaryText$1 as ListSecondaryText, ListSecondaryTextTest, ListSubtitle$1 as ListSubtitle, ListSubtitleTest, ListTest, ListThumbnail$1 as ListThumbnail, ListThumbnailTest, ListTitle$1 as ListTitle, ListTitleTest, LocationStyleListItem, LocationStyleListItemTest, Menu, MenuItem$1 as MenuItem, MenuItemTest, MenuTest, Modal, ModalButtonsAlignment, ModalCloseIconType, ModalStyledText, ModalTest, MoreActionsButton$1 as MoreActionsButton, MoreActionsButtonTest, NotificationManager, PageTitle, PageTitleTest, PlanBox, PlanBoxTest, Portal, PortalModal, PortalModalTest, ProfileInfoHeader$1 as ProfileInfoHeader, ProfileInfoHeaderTest, Quote$1 as Quote, QuoteTest, RadioButton, RadioButtonTest, RegularStyleListItem, RegularStyleListItemTest, Ribbon, RibbonTest, RibbonType, SafeArea, ScrollableContent, ScrollableContentTest, SelectionBar, SelectionBarTest, SideNavigationMenu, SideNavigationMenuTest, Slider, SliderTest, Spinner, SpinnerTest, StepBar, StepBarTest, Header as StyledHeader, StyledHeaderTest, StyledInstruction$1 as StyledInstruction, StyledInstructionTest, Svg$1 as Svg, SvgTest, Switch, SwitchTest, TabPanel, TabPanelTest, Tabs, TabsTest, TextField, TextFieldAdapter, TextFieldTest, TransparentButton$1 as TransparentButton, TransparentButtonTest, makeClickableListItem };
//# sourceMappingURL=index.es.js.map
